var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense, useEffect, useState } from "react";
import { useStyles } from "./assets/style";
import "./assets/style.css"; // @ts-ignore
import { icons, sizesIcon, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { themeCore } from "../../assets/themes/theme";
import * as catalogConst from "../../const/catalog";
import { STEP_CONFIRMATIONFORM } from "../../const/catalog";
import { formatPhoneNumber } from "../../utils/formats";
import { navigateNext, stepProgress } from "../../dataBase/stepProgress";
import { Customer } from "../../enum/customer";
import { Steps } from "../../enum/steps";
import { PostUploadDocuments } from "../../fnx/apaAuditDocuments/quoteUploadDocuments";
import { GetCatalogBeneficiary } from "../../fnx/catalog/getCatalogBeneficiary";
import { GetCatalogInsurance } from "../../fnx/catalog/getCatalogInsurance";
import { GetPaymentMode } from "../../fnx/paymentMode/getPaymentMode";
import { useCertificateQuote } from "../../fnx/certificate/certificateQuotes";
import { getCustomerAction, isAcap, isCustomer } from "../../fnx/customer";
import { GetPersonByDocument } from "../../fnx/person/getPersonByDocument";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { formatDocument, getLogin, transformToSelect, } from "../../services/functions";
import { hasPermission } from "../../services/getNavigationPages";
import LocalStorageService from "../../services/localStorage";
import showToast from "../../services/toast";
import { postQuoteUploadDocumentClearData } from "../../store/apapUploadAttachments/actions";
import { benefitClearData, getBeneficiary, patchBeneficiaryClearData, } from "../../store/beneficiary/actions";
import { certificateQuoteClearData } from "../../store/certificates/actions";
import { countries } from "../../store/countries/actions";
import { quoteClearData, quoteOne } from "../../store/generateQuote/actions";
import { identificationType } from "../../store/identificationType/actions";
import { deleteInsured as deleteInsuredAction, deleteInsuredClearData, insured, patchInsuredClearData, postInsuredClearData, } from "../../store/insured/actions";
import { pageActionFlagsClearData } from "../../store/pageActionFlags/actions";
import { personByDocumentClearData } from "../../store/person/actions";
import { catalogGender } from "../../store/plan/actions";
import { plans } from "../../store/plans/actions";
import { projectOne, projectOneClearData } from "../../store/project/actions";
import { region } from "../../store/region/actions";
import { patchQuoteClearData } from "../../store/updateQuote/actions";
import { formattedDate, newFormattedDate } from "../../utils/date";
import { formatNumberCustom, formatToTwoDecimals, parsePrice, } from "../../utils/getPrice";
import { AdditionalDocumentationColumns, dataEditVehicleForm, rowsClientDocument, StatementColumns, Tab1Columns, Tab2Columns, Tab3Columns, Tab4Columns, TabAutoColumns, TabAppointmentColumns, TabAppointmentManagerColumns } from "./resources/confirmationFormDto";
import { ConfirmationFormView } from "./ui/view"; /* Beneficiary */
import useBeneficiary from "./components/beneficiary"; /* Insurance */
import useInsurance from "./components/insurance"; /* Vehicle */
import useVehicle from "./components/vehicle"; /* ConfirmationForm */
import useClient from "./components/client"; /* Form Actions */
import useActions from "./components/ui"; /* Selectors */
import useSelectors from "./components/selectors"; /* Functions */
import useFunctions from "./components/functions";
import { PassengerDownloadModal } from "./resources/PassengerDownloadModal";
import PagesHeader from "ah_utility/PagesHeader";
import { useGetSteps } from "../../utils/getSteps";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
import { ConfirmationHeader } from "./header";
import { useGetInformationSteps } from "ah_utility/workflow";
import { useGetSummary } from "../../utils/getSummary";
import { useStepNavigation } from "ah_utility/NavigationEngine";
import { formAddBusiness } from "./resources/FormsBusinessDTO";
import { useCatalogues } from "../addBusiness/hooks/useCatalogues";
import { useStartWokFlow } from "../../fnx/workFlow/startWorkFlow";
import { startWorkFlowClearData } from "../../store/workFlow/actions";
import { addStepInformationToAllSteps } from "ah_utility/workflow";
import { addToSummary } from "ah_utility/fnxUtils";
import { useErrorHandling } from "./hooks/useErrorHandling";
import { useAppointment } from "./hooks/useAppointment";
import { useAppointmentManager } from "./hooks/useAppointmentManager";
var STEP = STEP_CONFIRMATIONFORM;
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
var storageKey3 = "afy-action-flags";
var lsPageActionFlags = new LocalStorageService(storageKey3);
var storageKey4 = "afy-steps";
var lsSteps = new LocalStorageService(storageKey4);
var ConfirmationForm = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    var permissions = {
        create: hasPermission("sale-confirmation-form-create"),
    };
    // -- DATA & STATES BUSINESS HOME
    var _v = React.useState(false), openModalAddBusiness = _v[0], setOpenModalAddBusiness = _v[1];
    var _w = React.useState(false), showTabRealEstates = _w[0], setShowTabRealEstates = _w[1];
    var _x = useState(formAddBusiness), dataFormBusiness = _x[0], setDataFormBusiness = _x[1];
    var _y = React.useState(false), isCommerce = _y[0], setIsCommerce = _y[1];
    var _z = useState(""), provinceId = _z[0], setProvinceId = _z[1];
    var _0 = useState(""), townId = _0[0], setTowId = _0[1];
    var _1 = useState(""), sectorId = _1[0], setSectorId = _1[1];
    var _2 = useState(""), planCode = _2[0], setPlanCode = _2[1];
    var _3 = useState(""), productCode = _3[0], setProductCode = _3[1];
    var _4 = useState([]), rowsProperties = _4[0], setRowsProperties = _4[1];
    var _5 = useState(""), propertyTypeId = _5[0], setPropertyTypeId = _5[1];
    var _6 = React.useState(""), damageBackup = _6[0], setDamageBackup = _6[1];
    var _7 = React.useState(""), insuredProperty = _7[0], setInsuredProperty = _7[1];
    // HOME
    var _8 = React.useState(false), openModalAddHome = _8[0], setOpenModalAddHome = _8[1];
    var _9 = React.useState(false), showFormBusiness = _9[0], setShowFormBusiness = _9[1];
    // -- END DATA & STATES BUSINESS HOME
    //APPOINMENT
    var _10 = React.useState(false), showTabAppointment = _10[0], setShowTabAppointment = _10[1];
    var _11 = React.useState(false), showTabAppointmentManager = _11[0], setShowTabAppointmentManager = _11[1];
    var _12 = React.useState(true), addAppointmentAction = _12[0], setAddAppointmentAction = _12[1];
    var _13 = React.useState(false), openModalAddAppointmentAction = _13[0], setOpenModalAddAppointmentAction = _13[1];
    var t = useTranslation().t;
    var classes = useStyles();
    var storageKey = "afy-steps";
    var localStorageService = new LocalStorageService(storageKey);
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _14 = React.useState(lsPageActionFlags.getPageActionFlagsStored()), actionFlags = _14[0], setActionFlags = _14[1];
    var _15 = useState(""), planId = _15[0], setPlanId = _15[1];
    var _16 = React.useState(false), openDrawerUpload = _16[0], setOpenDrawerUpload = _16[1];
    var _17 = React.useState(""), idDocumentClient = _17[0], setIdDocumentClient = _17[1];
    var _18 = useState(""), coverTypeId = _18[0], setCoverTypeId = _18[1];
    var _19 = useState(""), campaignId = _19[0], setCampaignId = _19[1];
    var _20 = useState(""), catalogPaymentMode = _20[0], setCatalogPaymentMode = _20[1];
    var _21 = useState(""), catalogStatusQuote = _21[0], setCatalogStatusQuote = _21[1];
    var _22 = useState(""), branchId = _22[0], setBranchId = _22[1];
    var userId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _23 = React.useState(false), uploadTrigger = _23[0], setUploadTrigger = _23[1];
    var isVidaTermino = isCustomer(Customer.VIDA);
    var _24 = React.useState(""), period = _24[0], setPeriod = _24[1];
    var _25 = React.useState([]), breadCrumbs = _25[0], setBreadCrumbs = _25[1];
    var _26 = React.useState(false), showInsured = _26[0], setShowInsured = _26[1];
    var _27 = React.useState(false), showNewFormInsurance = _27[0], setShowNewFormInsurance = _27[1];
    var _28 = React.useState(false), showBeneficiary = _28[0], setShowBeneficiary = _28[1];
    var _29 = React.useState(true), addInsured = _29[0], setAddInsured = _29[1];
    var _30 = React.useState(true), addBeneficiary = _30[0], setAddBeneficiary = _30[1];
    var _31 = React.useState(false), showComponent = _31[0], setShowComponent = _31[1];
    var _32 = useState(false), openModalBackConfirm = _32[0], setOpenModalBackConfirm = _32[1];
    var _33 = React.useState(true), canEdit = _33[0], setCanEdit = _33[1];
    var _34 = React.useState(false), showDownloads = _34[0], setShowDownloads = _34[1];
    var _35 = React.useState(false), canEditLocation = _35[0], setCanEditLocation = _35[1];
    var _36 = React.useState(false), canEditContact = _36[0], setCanEditContact = _36[1];
    var _37 = React.useState([]), certificates = _37[0], setCertificates = _37[1];
    var _38 = useState([]), rows = _38[0], setRows = _38[1];
    var _39 = useState([]), rows2 = _39[0], setRows2 = _39[1];
    var _40 = useState([]), rowsBeneficiary = _40[0], setRowsBeneficiary = _40[1];
    var _41 = useState([]), rowsPassengers = _41[0], setRowsPassengers = _41[1];
    var _42 = React.useState(false), openActivePolicy = _42[0], setOpenActivePolicy = _42[1];
    var activatePolicy = useParams().activatePolicy;
    var showButtonActivatePolicy = React.useState(!!activatePolicy)[0];
    var _43 = React.useState(""), policyId = _43[0], setPolicyId = _43[1];
    var _44 = React.useState(false), hideMarriedName = _44[0], setHideMarriedName = _44[1];
    var _45 = React.useState(""), namePlan = _45[0], setNamePlan = _45[1];
    var _46 = useState(false), isMaskedDocument = _46[0], setIsMaskedDocument = _46[1];
    var _47 = useState(""), personQuoteId = _47[0], setPersonQuoteId = _47[1];
    var _48 = useState(""), prime = _48[0], setPrime = _48[1];
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _49 = React.useState(true), enable = _49[0], setEnable = _49[1];
    var _50 = React.useState([]), listIdentificationType = _50[0], setListIdentificationType = _50[1];
    var _51 = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _51[0], setSeeToast = _51[1];
    var id = useParams().id;
    var isQuote = useParams().isQuote;
    var isPlan = useParams().isPlan;
    var idProject = useParams().idProject;
    var isDocumentClient = useParams().isDocumentClient;
    var _52 = React.useState(false), projectTrigger = _52[0], setProjectTrigger = _52[1];
    var _53 = React.useState(false), triggerCatalog = _53[0], setTriggerCatalog = _53[1];
    var _54 = React.useState(false), triggerCatalogInsurance = _54[0], setTriggerCatalogInsurance = _54[1];
    var _55 = React.useState(false), triggerPaymentMode = _55[0], setTriggerPaymentMode = _55[1];
    var _56 = React.useState(false), triggerCertificate = _56[0], setTriggerCertificate = _56[1];
    var _57 = useState([]), listGenders = _57[0], setListGenders = _57[1];
    var _58 = useState(isQuote === "true"), isQuoteType = _58[0], setIsQuoteType = _58[1];
    var _59 = useState(true), canEditBeneficiary = _59[0], setCanEditBeneficiary = _59[1];
    var _60 = useState(true), canEditInsured = _60[0], setCanEditInsured = _60[1];
    var _61 = useState([]), listCountries = _61[0], setListCountries = _61[1];
    var _62 = useState([]), listRegionLevel1 = _62[0], setListRegionLevel1 = _62[1];
    var _63 = useState([]), listRegionLevel2 = _63[0], setListRegionLevel2 = _63[1];
    var _64 = useState([]), listRegionLevel3 = _64[0], setListRegionLevel3 = _64[1];
    var _65 = React.useState(1), page = _65[0], setPage = _65[1];
    var _66 = React.useState(""), idQuoteVehicle = _66[0], setIdQuoteVehicle = _66[1];
    var _67 = React.useState(""), productId = _67[0], setProductId = _67[1];
    var _68 = React.useState(10000), limit = _68[0], setLimit = _68[1];
    var _69 = React.useState(false), openModal = _69[0], setOpenModal = _69[1];
    var _70 = React.useState(false), openModalAddInsurance = _70[0], setOpenModalAddInsurance = _70[1];
    var _71 = React.useState(false), openModalPdfViewer = _71[0], setopenModalPdfViewer = _71[1];
    var _72 = React.useState(""), urlDocument = _72[0], setUrlDocument = _72[1];
    var _73 = React.useState(""), nameDocument = _73[0], setNameDocument = _73[1];
    var _74 = React.useState(""), personId = _74[0], setPersonId = _74[1];
    var _75 = React.useState(false), openModalBeneficiary = _75[0], setOpenModalBeneficiary = _75[1];
    var _76 = React.useState(transformToSelect(localStorageService.getStepStored().steps[Steps.plan].paymentMode)), paymentMode = _76[0], setPaymentMode = _76[1];
    var _77 = React.useState([
        { id: 1, name: "Sin datos", value: "-1" },
    ]), coverageType = _77[0], setCoverageType = _77[1];
    var _78 = React.useState([
        { id: 1, name: "Sin datos", value: "-1", code: "" },
    ]), insuredType = _78[0], setInsuredType = _78[1];
    var _79 = React.useState([
        { id: 1, name: "Sin datos", value: "-1" },
    ]), beneficiaryType = _79[0], setBeneficiaryType = _79[1];
    var _80 = React.useState(localStorageService.getStepStored().steps[Steps.insurance].campaign), campaign = _80[0], setCampaign = _80[1];
    var _81 = React.useState(""), planName = _81[0], setPlanName = _81[1];
    var _82 = React.useState(localStorageService.getStepStored().steps[Steps.insurance].campaign), campaigns = _82[0], setCampaigns = _82[1];
    var _83 = React.useState({
        id: (_b = (_a = localStorageService.getStepStored().steps[Steps.customer].campaignSelected) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "",
        name: (_d = (_c = localStorageService.getStepStored().steps[Steps.customer].campaignSelected) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : "",
        value: (_f = (_e = localStorageService.getStepStored().steps[Steps.customer].campaignSelected) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : "",
    }), campaignSelected = _83[0], setCampaignSelected = _83[1];
    var _84 = React.useState({
        id: localStorageService.getStepStored().steps[Steps.customer].id,
        name: localStorageService.getStepStored().steps[Steps.customer].name,
    }), plan = _84[0], setPlan = _84[1];
    var _85 = React.useState(false), openModalEditVehicle = _85[0], setOpenModalEditVehicle = _85[1];
    var steps = useGetSteps();
    var _86 = React.useState({
        titlePage: "Plan",
        viewType: "2",
        titleMetaTag: "Affinity Plan",
        informationPage: {
            backgroundColor: themeCore.colors.background,
            colorText: themeCore.colors.secondaryText,
            description: "Seleccion el plan que necesite el cliente",
            icon: icons.Help,
            iconSize: sizesIcon.standard,
            iconColor: themeCore.colors.primary,
        },
        filter: {
            backgroundColor: "#FFFFFF",
            bgChipInsurers: "#fff",
            bgChipInsurersSelected: "#EBEEF6",
            bgColorButton: "#fff",
            bgColorComparativeButton: "#3A56A1",
            bgColorIconButton: "#EBEEF6",
            bgColorIconButtonSelected: "#3A56A1",
            colorIconButton: "#3A56A1",
            colorIconButtonSelected: "#fff",
            colorIconChip: "#3A56A1",
            colorText: "#3A56A1",
            comparativeTextButton: "ver comparativa",
            comparativeTextColor: "#fff",
            insurers: [],
            title: "Patrocinador",
            titleFirstChip: "Todas",
        },
        data: [],
    }), planData = _86[0], setPlanData = _86[1];
    var _87 = React.useState(localStorageService.getStepStored().steps[Steps.insurance].campaign), campaignInfo = _87[0], setCampaignInfo = _87[1];
    var level1 = "REGION_LEVEL1";
    var level2 = "REGION_LEVEL2";
    var level3 = "REGION_LEVEL3";
    var _88 = React.useState(), coverType = _88[0], setCoverType = _88[1];
    var _89 = useState("Confirmación de Datos"), titleInsured = _89[0], setTitleInsured = _89[1];
    var _90 = useState("Ingresar beneficiario"), titleBeneficiary = _90[0], setTitleBeneficiary = _90[1];
    var _91 = React.useState(findParamInLocalStorage("projectId") || ""), projectId = _91[0], setProjectId = _91[1];
    var _92 = React.useState(false), isTravelInsurance = _92[0], setIsTravelInsurance = _92[1];
    // Get passenger counts from localStorage and calculate sum
    var edad020 = parseInt(findParamInLocalStorage("edad020") || "0");
    var edad2174 = parseInt(findParamInLocalStorage("edad2174") || "0");
    var edad7585 = parseInt(findParamInLocalStorage("edad7585") || "0");
    var _93 = React.useState(edad020 + edad2174 + edad7585), premiumSum = _93[0], setPremiumSum = _93[1];
    var _94 = useState(false), isUpdate = _94[0], setIsUpdate = _94[1];
    var _95 = React.useState(dataEditVehicleForm), dataFormVehicle = _95[0], setDataFormVehicle = _95[1];
    var _96 = useState({
        DocumentNumber: "",
        QuoteNumber: "",
        QuoteStatusName: "",
        QuoteDate: "",
        Type: "",
        PlanTypeName: "",
        CampaignName: "-",
        IdTypeName: "",
        Name: "",
        SecondName: "",
        FirstLastName: "",
        SecondLastName: "",
        MarriedSurName: "-",
        Gender: "",
        Birthday: "",
        Address1: "-",
        Address2: "-",
        CountryName: "",
        ProvinceName: "",
        TownName: "",
        SectorName: "",
        PostalCode: "",
        PhoneOffice: "",
        PhoneHome: "-",
        PhoneNumber: "-",
        Email: "",
    }), dataForm = _96[0], setDataForm = _96[1];
    var _97 = useState({
        Id: "",
        IdType: "",
        idTypeInsured: "",
        Percentage: "",
        DocumentNumber: "",
        Name: "",
        LastNameA: "",
        LastNameB: "",
        marriedName: "",
        Birthday: "",
        PhoneNumber: "",
        IdTypeName: "",
    }), dataFormBeneficiary = _97[0], setDataFormBeneficiary = _97[1];
    var _98 = useState({
        Id: "",
        IdType: "",
        idInsuredType: "",
        DocumentNumber: "",
        Name: "",
        LastNameA: "",
        LastNameB: "",
        marriedName: "",
        Birthday: "",
        PhoneNumber: "",
        IdTypeName: "",
    }), dataFormInsurance = _98[0], setDataFormInsurance = _98[1];
    var _99 = useState({
        idType: "",
        documentNumber: "",
        idInsuredType: "",
        firstName: "",
        secondName: "",
        lastNameA: "",
        lastNameB: "",
        birthday: "",
        gender: "",
        marriedName: "",
        country: "",
        province: "",
        town: "",
        sector: "",
        postalCode: "",
        address1: "",
        phoneHome: "",
        phoneNumber: "",
        phoneOffice: "",
        email: "",
    }), dataFormInsuranceSp = _99[0], setDataFormInsuranceSp = _99[1];
    var _100 = useState(""), insuranceType = _100[0], setInsuranceType = _100[1];
    var _101 = useState(45), initialPercentage = _101[0], setInitialPercentage = _101[1];
    var _102 = useState(false), trigger = _102[0], setTrigger = _102[1];
    var _103 = useState(), document = _103[0], setDocument = _103[1];
    var _104 = useState(false), isInsurance = _104[0], setIsInsurance = _104[1];
    var _105 = useState([]), listVehiclesDetail = _105[0], setListVehicles = _105[1];
    var _106 = React.useState({}), salesFlow = _106[0], setSalesFlow = _106[1];
    var _107 = React.useState([]), statementRows = _107[0], setStatementRows = _107[1];
    var _108 = React.useState([]), filters = _108[0], setFilters = _108[1];
    var _109 = React.useState([]), defaultFilters = _109[0], setDefaultFilters = _109[1];
    var _110 = React.useState(rowsClientDocument), profileDocumentsRows = _110[0], setProfileDocumentsRows = _110[1];
    var _111 = React.useState(0), countBadge = _111[0], setCountBadge = _111[1];
    var carDetails = React.useState((_g = lsSteps.getStepStored().steps[Steps.vehiclesDetails]) === null || _g === void 0 ? void 0 : _g.vehiclesDetails)[0];
    var company = React.useState(lsLogin.getUserLoginStored().subdomain || "")[0];
    var isApapAuto = getCustomerAction().customerAuto.includes(company);
    var isAcapCompany = isAcap(company);
    var _112 = useState(true), hideTabDocumentClient = _112[0], setHideTabDocumentClient = _112[1];
    var _113 = useState(true), hideTabPaymentInfo = _113[0], setHideTabPaymentInfo = _113[1];
    var isNotQuote = isQuote !== "false";
    var isApapAutoWithoutQuote = isApapAuto && !isNotQuote;
    var _114 = React.useState(""), fileName = _114[0], setFileName = _114[1];
    var _115 = React.useState(), pdfFile = _115[0], setPdfFile = _115[1];
    var _116 = React.useState(false), modalDocumentClient = _116[0], setModalDocumentClient = _116[1];
    var _117 = React.useState(""), urlDocumentClient = _117[0], setUrlDocumentClient = _117[1];
    var _118 = React.useState("false"), docName = _118[0], setDocName = _118[1];
    var _119 = React.useState(false), openModalPassenger = _119[0], setOpenModalPassenger = _119[1];
    var _120 = React.useState(""), urlDocumentPassenger = _120[0], setUrlDocumentPassenger = _120[1];
    var _121 = React.useState(""), nameDocumentPassenger = _121[0], setNameDocumentPassenger = _121[1];
    var _122 = React.useState(((_h = localStorageService.getStepStored().steps[Steps.customer]) === null || _h === void 0 ? void 0 : _h.paymentModeSelected) || { id: "", name: "", value: "" }), paymentModelSelected = _122[0], setPaymentModelSelected = _122[1];
    var _123 = React.useState(localStorageService.getStepStored().steps[Steps.customer].coverType), coverTypeSelected = _123[0], setCoverTypeSelected = _123[1];
    var _124 = useState(""), productType = _124[0], setProductType = _124[1];
    var projectTypeLocal = React.useRef((_k = (_j = lsSteps.getStepStored().steps[Steps.insurance].flow) === null || _j === void 0 ? void 0 : _j.metadata) === null || _k === void 0 ? void 0 : _k.navigation.productType);
    var _125 = useState(""), quoteId = _125[0], setQuoteId = _125[1];
    var isApap = getCustomerAction().customerAuto.includes(company);
    var Quote = React.useState(findParamInLocalStorage("Quote"))[0];
    var quoteIdLS = Quote === null || Quote === void 0 ? void 0 : Quote.id;
    var summary = useGetSummary();
    var pathname = useLocation().pathname;
    var pathLocation = "/" + pathname.split("/")[1];
    var _126 = React.useState({}), sessionData = _126[0], setSessionData = _126[1];
    var _127 = React.useState(false), triggerStart = _127[0], setTriggerStart = _127[1];
    var workFlow = localStorage.getItem("WorkFlowId");
    var _128 = useState(""), instanceIdR = _128[0], setInstanceIdR = _128[1];
    var _129 = useState(""), currentStepId = _129[0], setCurrentStepId = _129[1];
    var _130 = useState(""), nextStepId = _130[0], setNextStepId = _130[1];
    // ✅ Flag para refrescar la información de los pasos
    var _131 = useState(0), refreshStepsInfo = _131[0], setRefreshStepsInfo = _131[1];
    var _132 = useStepNavigation({
        currentStepId: pathLocation,
        sessionData: sessionData,
        autoValidate: true,
    }), navigation = _132.navigation, isNextDisabled = _132.isNextDisabled, validationResult = _132.validationResult;
    // ✅ Ahora pasa el refreshTrigger para recargar cuando cambie
    var _133 = useGetInformationSteps(pathLocation, { refreshTrigger: refreshStepsInfo }), instanceId = _133.instanceId, workFlowId = _133.workFlowId, currentStep = _133.currentStep, nextStep = _133.nextStep;
    // Ref para controlar si ya se inicializó el país una vez
    var countryInitializedRef = React.useRef(false);
    var actionFlagsFound = findParamInLocalStorage("", "afy-action-flags");
    var flagFound = actionFlagsFound === null || actionFlagsFound === void 0 ? void 0 : actionFlagsFound.find(function (flag) { return flag.name === "afy-confirm-filter-insurances-by-plan"; });
    var flagFilterInsuranceTypeByPlan = (flagFound === null || flagFound === void 0 ? void 0 : flagFound.value) === "true";
    var shouldFilterByCoverType = coverTypeId === "43430f8b-8fe3-4582-8d11-6f9edf69bb9e" &&
        flagFilterInsuranceTypeByPlan;
    var planIdForCatalog = shouldFilterByCoverType ? planId : undefined;
    var _134 = useState([]), downloadsStatusDenyList = _134[0], setDownloadsStatusDenyList = _134[1];
    var _135 = useState([]), showTabPaymentStatusAllowList = _135[0], setShowTabPaymentStatusAllowList = _135[1];
    var _136 = useState(false), isThereTabPaymentStatusAllowList = _136[0], setIsThereShowTabPaymentStatusAllowList = _136[1];
    var _137 = useSelectors(), loadingUpdateQuote = _137.loadingUpdateQuote, errorUpdateQuote = _137.errorUpdateQuote, responseIdentificationType = _137.responseIdentificationType, errorIdentificationType = _137.errorIdentificationType, responseCatalogGender = _137.responseCatalogGender, errorCatalogGender = _137.errorCatalogGender, responsePlan = _137.responsePlan, errorPlan = _137.errorPlan, loading = _137.loading, responseCountries = _137.responseCountries, errorCountries = _137.errorCountries, responseRegion = _137.responseRegion, errorRegion = _137.errorRegion, responsePlans = _137.responsePlans, errorPlans = _137.errorPlans, loadingPlans = _137.loadingPlans, responseInsured = _137.responseInsured, errorInsured = _137.errorInsured, responseDeleteInsured = _137.responseDeleteInsured, errorDeleteInsured = _137.errorDeleteInsured, loadingDeleteInsured = _137.loadingDeleteInsured, responsePostInsured = _137.responsePostInsured, errorPostInsured = _137.errorPostInsured, loadingPostInsured = _137.loadingPostInsured, responsePatchInsured = _137.responsePatchInsured, errorPatchInsured = _137.errorPatchInsured, loadingPatchInsured = _137.loadingPatchInsured, responseUpdatePerson = _137.responseUpdatePerson, errorUpdatePerson = _137.errorUpdatePerson, loadingUpdatePerson = _137.loadingUpdatePerson, responseBenefit = _137.responseBenefit, errorBenefit = _137.errorBenefit, loadingBenefit = _137.loadingBenefit, responsePatchBeneficiary = _137.responsePatchBeneficiary, errorPatchBeneficiary = _137.errorPatchBeneficiary, loadingPatchBeneficiary = _137.loadingPatchBeneficiary, responseBeneficiary = _137.responseBeneficiary, errorBeneficiary = _137.errorBeneficiary, loadingBeneficiary = _137.loadingBeneficiary, responsePageActionFlags = _137.responsePageActionFlags, responseOneProject = _137.responseOneProject, loadingOneProject = _137.loadingOneProject, errorOneQuote = _137.errorOneQuote, responseOneQuote = _137.responseOneQuote, loadingOneQuote = _137.loadingOneQuote, loadingInsured = _137.loadingInsured, responsePatchQuote = _137.responsePatchQuote, errorPatchQuote = _137.errorPatchQuote, loadingPatchQuote = _137.loadingPatchQuote;
    var updateVehicle = useVehicle(setOpenModalEditVehicle).updateVehicle;
    var _138 = useClient(paymentMode, setPeriod, setPaymentModelSelected, setPaymentMode, paymentModelSelected, coverTypeSelected, plans, enable, page, limit, projectId, namePlan, clientId, setCoverTypeSelected, campaigns, setCampaignSelected, level2, level3, setListRegionLevel3, listGenders, setHideMarriedName, setCoverType, setPlan, campaignSelected, personQuoteId, hideMarriedName, salesFlow, setCampaign, setCampaigns, setFileName, setPdfFile, setUploadTrigger, actionFlags, isQuote, setShowInsured, setAddInsured, setShowBeneficiary, setAddBeneficiary, setCanEditInsured, setCanEditBeneficiary, responseOneQuote, setTriggerCertificate, setUrlDocument, setopenModalPdfViewer, catalogPaymentMode, setDataForm, setDefaultFilters, setPrime, dataForm, setShowNewFormInsurance, setShowTabRealEstates, setShowFormBusiness, setShowTabAppointment, setShowTabAppointmentManager, (_l = id !== null && id !== void 0 ? id : quoteId) !== null && _l !== void 0 ? _l : "", userId), searchPerson = _138.searchPerson, handleSearch = _138.handleSearch, callDispatchPlan = _138.callDispatchPlan, callDispatchPlanAfterQuoteLoaded = _138.callDispatchPlanAfterQuoteLoaded, handleOnChangePaymentMethod = _138.handleOnChangePaymentMethod, handleOnChangeCoverType = _138.handleOnChangeCoverType, handleOnChangeCampaign = _138.handleOnChangeCampaign, handleChangeSelect = _138.handleChangeSelect, handleChangeSelectFormInsurance = _138.handleChangeSelectFormInsurance, handleUpdatePerson = _138.handleUpdatePerson, handleDownload = _138.handleDownload, updateDataFormPerson = _138.updateDataFormPerson, setCoverTypeStorybook = _138.setCoverTypeStorybook, handleOnClickAcquire = _138.handleOnClickAcquire, quoteUploadDocuments = _138.quoteUploadDocuments, callQuoteOne = _138.callQuoteOne, getActionFlags = _138.getActionFlags, handleOnClickAutoDownload = _138.handleOnClickAutoDownload, handleOnClickAutoDownloadVida = _138.handleOnClickAutoDownloadVida, setLocalStorage = _138.setLocalStorage, callDispatchPageActionFlags = _138.callDispatchPageActionFlags, showVehicleData = _138.showVehicleData, showDownloadQuote = _138.showDownloadQuote, showDownloadRequest = _138.showDownloadRequest;
    var _139 = useInsurance(setTitleInsured, setIsUpdate, setOpenModal, setOpenModalAddInsurance, dataFormInsurance, setDataFormInsurance, dataFormInsuranceSp, setDataFormInsuranceSp, insuranceType, setRows, responseOneQuote, quoteId ? quoteId : id, clientId, personId, isUpdate, setIsMaskedDocument, setPersonId, listIdentificationType, insuredType, setIsInsurance, setDocument, setTrigger, showNewFormInsurance, setSeeToast), handleAddInsured = _139.handleAddInsured, setInsuranceStorybook = _139.setInsuranceStorybook, handleSubmitInsured = _139.handleSubmitInsured, editInsured = _139.editInsured, searchInsurancePerson = _139.searchInsurancePerson;
    var _140 = useBeneficiary(setIsUpdate, setInitialPercentage, setTitleBeneficiary, setOpenModalBeneficiary, dataFormBeneficiary, setDataFormBeneficiary, initialPercentage, responseOneQuote, clientId, isUpdate, setIsMaskedDocument, setPersonId, listIdentificationType), setBeneficiaryStorybook = _140.setBeneficiaryStorybook, handleAddBeneficiary = _140.handleAddBeneficiary, handleSubmitBeneficiary = _140.handleSubmitBeneficiary, getInsuredBeneficiary = _140.getInsuredBeneficiary, editBeneficiary = _140.editBeneficiary;
    var _141 = useActions(setOpenDrawerUpload, setPdfFile, setFileName, setIdDocumentClient, setModalDocumentClient, setUrlDocumentClient, setDocName, isVidaTermino, navigate, navigateNext, STEP, id, setOpenModalBackConfirm, isPlan, isDocumentClient, workFlowId, instanceId, currentStep, nextStep, currentStepId, nextStepId, pathLocation, navigation), handleNext = _141.handleNext, handlePrevious = _141.handlePrevious, onClickBack = _141.onClickBack, handleCloseBackModal = _141.handleCloseBackModal, handleBackFromModal = _141.handleBackFromModal, handleClickContextMenu = _141.handleClickContextMenu, loadingComplete = _141.loadingComplete;
    var filterData = useFunctions().filterData;
    var _142 = useCertificateQuote(triggerCertificate, "cotizacion", quoteId, 1, 20), responseCertificateQuote = _142.responseCertificateQuote, errorCertificateQuote = _142.errorCertificateQuote, loadingCertificateQuote = _142.loadingCertificateQuote;
    var _143 = useCatalogues(propertyTypeId), loadingCatalogues = _143.loadingCatalogues, errorCatalogues = _143.errorCatalogues, businessType = _143.businessType, typeConstruction = _143.typeConstruction, businessShift = _143.businessShift;
    var _144 = PostUploadDocuments(uploadTrigger, id ? id : quoteId, fileName, pdfFile, idDocumentClient), responseUploadDocuments = _144.responseUploadDocuments, errorUploadDocuments = _144.errorUploadDocuments, loadingUploadDocuments = _144.loadingUploadDocuments;
    var _145 = GetCatalogBeneficiary(triggerCatalog, enable, page, limit, clientId), responseGetCatalogBeneficiary = _145.responseGetCatalogBeneficiary, errorGetCatalogBeneficiary = _145.errorGetCatalogBeneficiary, loadingGetCatalogBeneficiary = _145.loadingGetCatalogBeneficiary;
    var _146 = GetCatalogInsurance(triggerCatalogInsurance, enable, page, limit, clientId, planIdForCatalog), responseGetCatalogInsurance = _146.responseGetCatalogInsurance, errorGetCatalogInsurance = _146.errorGetCatalogInsurance, loadingGetCatalogInsurance = _146.loadingGetCatalogInsurance;
    var _147 = GetPersonByDocument(trigger, document), responsePersonByDocument = _147.responsePersonByDocument, errorPersonByDocument = _147.errorPersonByDocument, loadingPersonByDocument = _147.loadingPersonByDocument;
    var _148 = GetPaymentMode(triggerPaymentMode, projectId || idProject || ""), responsePaymentMode = _148.responsePaymentMode, errorPaymentMode = _148.errorPaymentMode, loadingPaymentMode = _148.loadingPaymentMode;
    var onSameDirection = function (checked, data) {
        var _a;
        if (data === "sameAddress") {
            if (checked === true) {
                var addressFromQuote_1 = ((_a = responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.address1) || "";
                setDataFormBusiness(function (prev) { return ({
                    Province: provinceId,
                    Town: townId,
                    Sector: sectorId,
                    propertyAddress: addressFromQuote_1,
                }); });
            }
            else {
                setDataFormBusiness(function (prev) { return ({
                    Province: "",
                    Town: "",
                    Sector: "",
                    propertyAddress: "",
                }); });
            }
        }
    };
    var _149 = useStartWokFlow(triggerStart, workFlow !== null && workFlow !== void 0 ? workFlow : "", function () { return setTriggerStart(false); }), loadingStartWorkFlow = _149.loadingStartWorkFlow, responseStartWorkFlow = _149.responseStartWorkFlow, errorStartWorkflow = _149.errorStartWorkflow;
    useErrorHandling({
        errorPersonByDocument: errorPersonByDocument,
        errorOneQuote: errorOneQuote,
        errorInsured: errorInsured,
        errorCatalogGender: errorCatalogGender,
        errorCountries: errorCountries,
        errorRegion: errorRegion,
        errorUpdateQuote: errorUpdateQuote,
        errorPlan: errorPlan,
        errorBeneficiary: errorBeneficiary,
        errorIdentificationType: errorIdentificationType,
        errorUpdatePerson: errorUpdatePerson,
        errorPatchBeneficiary: errorPatchBeneficiary,
        errorPatchInsured: errorPatchInsured,
        errorBenefit: errorBenefit,
        errorPostInsured: errorPostInsured,
        errorPlans: errorPlans,
        errorUploadDocuments: errorUploadDocuments,
        errorPaymentMode: errorPaymentMode,
        errorCertificateQuote: errorCertificateQuote,
        errorStartWorkflow: errorStartWorkflow,
        setSeeToast: setSeeToast,
    });
    useEffect(function () {
        var _a;
        dispatch(pageActionFlagsClearData());
        // Remove summary from localStorage if coming from insurancePoliciesSummary
        if (idProject) {
            localStorage.removeItem("summary");
        }
        setProjectTrigger(true);
        if (idProject || projectId) {
            dispatch(projectOne({
                id: idProject ? idProject : projectId,
            }));
        }
        setTriggerCatalog(true);
        setTriggerPaymentMode(true);
        getActionFlags();
        if (!responseIdentificationType) {
            dispatch(identificationType({ enable: enable, page: page, limit: limit }));
        }
        if (!responseCountries) {
            dispatch(countries({ enable: enable, page: page, limit: limit }));
        }
        if (!(responseCatalogGender === null || responseCatalogGender === void 0 ? void 0 : responseCatalogGender.data)) {
            dispatch(catalogGender({ enable: enable, page: page, limit: limit }));
        }
        //Get Quote //
        var quoteIdLs = quoteIdLS;
        if (id !== undefined) {
            dispatch(quoteClearData());
            setCanEdit(isQuoteType);
            if (!isQuoteType) {
                setCanEditLocation(true);
                setCanEditContact(true);
            }
            //Get the quote by id
            callQuoteOne(id);
        }
        else {
            callQuoteOne(quoteIdLs);
        }
        callGetInsuredBeneficiary((_a = id !== null && id !== void 0 ? id : quoteIdLs) !== null && _a !== void 0 ? _a : "");
        // Note: callDispatchPlan moved to useEffect that waits for responseOneQuote
        //if (permissionList?.length === 0) {
        //setTriggerPermissionList(true);
        //}
        //if (permissionList?.length === 0) {
        //setTriggerPermissionList(true);
        //}
    }, []);
    useEffect(function () {
        if (id !== undefined) {
            dispatch(quoteClearData());
            callQuoteOne(id);
        }
    }, [id]);
    // startFlow
    useEffect(function () {
        if (id !== undefined || isQuoteType) {
            setTriggerStart(true);
        }
    }, [workFlow]);
    useEffect(function () {
        var _a, _b;
        if (responseStartWorkFlow) {
            var nextStepId_1 = ((_a = responseStartWorkFlow.nextSteps[0]) === null || _a === void 0 ? void 0 : _a.nextSteps[0]) || "";
            setInstanceIdR(responseStartWorkFlow.instanceId);
            setCurrentStepId((_b = responseStartWorkFlow.currentStep) === null || _b === void 0 ? void 0 : _b.id);
            setNextStepId(nextStepId_1);
            localStorage.setItem("Quote", id !== null && id !== void 0 ? id : "");
            addStepInformationToAllSteps(workFlow !== null && workFlow !== void 0 ? workFlow : "", responseStartWorkFlow.instanceId);
            // Refrescar la información de los pasos después de actualizar localStorage
            setRefreshStepsInfo(function (prev) { return prev + 1; });
            dispatch(startWorkFlowClearData());
        }
    }, [responseStartWorkFlow]);
    //end startFlow
    useEffect(function () {
        var _a, _b, _c;
        if (responsePaymentMode && responsePaymentMode.length > 0) {
            // Transform payment mode response to select format
            var paymentModeList_1 = [];
            var quotePaymentModeId_1 = (_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.id;
            responsePaymentMode.map(function (item) {
                var _a, _b, _c, _d;
                var itemId = ((_a = item.catalogPaymentMode) === null || _a === void 0 ? void 0 : _a.id) || item.id;
                paymentModeList_1.push({
                    id: itemId,
                    name: ((_b = item.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.description) || item.description || "",
                    value: ((_c = item.catalogPaymentMode) === null || _c === void 0 ? void 0 : _c.code) ||
                        ((_d = item.catalogPaymentMode) === null || _d === void 0 ? void 0 : _d.id) ||
                        item.id,
                    default: quotePaymentModeId_1 ? itemId === quotePaymentModeId_1 : false,
                });
            });
            setPaymentMode(paymentModeList_1);
            // Set initial payment mode selection only if not already set and no quote data available
            if (!(paymentModelSelected === null || paymentModelSelected === void 0 ? void 0 : paymentModelSelected.id) &&
                paymentModeList_1.length > 0 &&
                !((_c = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.catalogPaymentMode)) {
                setPaymentModelSelected(paymentModeList_1[0]);
                // Set initial period when payment mode is first loaded
                setPeriod(paymentModeList_1[0].name);
            }
        }
    }, [responsePaymentMode, (_o = (_m = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _m === void 0 ? void 0 : _m.catalogPaymentMode) === null || _o === void 0 ? void 0 : _o.id]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            setRowsPassengers((((_a = responseOneQuote.data.contentMap) === null || _a === void 0 ? void 0 : _a.additionalTravelers) || []).map(function (t) {
                var birthday = t.birthday || t.Birthday || "";
                var edad = "";
                if (birthday) {
                    var birth = new Date(birthday);
                    // Handle DD/MM/YYYY format
                    if (isNaN(birth.getTime())) {
                        var parts = birthday.split("/");
                        if (parts.length === 3) {
                            birth = new Date("".concat(parts[2], "-").concat(parts[1], "-").concat(parts[0]));
                        }
                    }
                    if (!isNaN(birth.getTime())) {
                        var today = new Date();
                        var age = today.getFullYear() - birth.getFullYear();
                        var m = today.getMonth() - birth.getMonth();
                        if (m < 0 || (m === 0 && today.getDate() < birth.getDate()))
                            age--;
                        edad = String(age);
                    }
                }
                return __assign(__assign({}, t), { birthday: birthday, edad: edad });
            }));
            var combustionMap = {
                GASOLINE: "Gasolina",
                DIESEL: "Diesel",
                ELECTRIC: "Eléctrico",
                GAS: "Gas",
            };
            var combustionType = (_b = responseOneQuote.data.contentMap) === null || _b === void 0 ? void 0 : _b.combustion;
            var carCombustion = combustionMap[combustionType] || "";
            var price = parsePrice(((_c = responseOneQuote.data.contentMap) === null || _c === void 0 ? void 0 : _c.deductibleTypeId) || 0);
            var newPrice = formatNumberCustom(price || 0);
            var car = {
                id: 1,
                brand: (_e = (_d = responseOneQuote.data.contentMap) === null || _d === void 0 ? void 0 : _d.brand) === null || _e === void 0 ? void 0 : _e.name,
                model: (_g = (_f = responseOneQuote.data.contentMap) === null || _f === void 0 ? void 0 : _f.model) === null || _g === void 0 ? void 0 : _g.name,
                fueltype: carCombustion,
                color: (_j = (_h = responseOneQuote.data.contentMap) === null || _h === void 0 ? void 0 : _h.colors) === null || _j === void 0 ? void 0 : _j.name,
                price: "RD$ ".concat(newPrice),
                cylinders: (_k = responseOneQuote.data.contentMap) === null || _k === void 0 ? void 0 : _k.cylinders,
                plate: (_l = responseOneQuote.data.contentMap) === null || _l === void 0 ? void 0 : _l.plate,
            };
            var vehicleDet = [];
            vehicleDet.push(car);
            setListVehicles(vehicleDet);
        }
    }, [responseOneQuote]);
    // Llenar datos de propiedad inmobiliaria
    useEffect(function () {
        var _a, _b, _c, _d;
        if (responseOneQuote && ((_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.contentMap)) {
            var contentMap_1 = responseOneQuote.data.contentMap;
            setPropertyTypeId(contentMap_1.propertyTypeId || "");
            setDamageBackup(formatToTwoDecimals(contentMap_1.damageBackup));
            setInsuredProperty(formatToTwoDecimals(contentMap_1.insuredProperty));
            setDataFormBusiness({
                ownerName: contentMap_1.ownerName,
                ownerIdNumber: contentMap_1.ownerIdNumber,
                propertyTypeId: contentMap_1.propertyTypeId,
                businessShift: contentMap_1.businessShift,
                sameAddress: contentMap_1.sameAddress,
                Province: contentMap_1.province,
                Town: contentMap_1.town,
                Sector: contentMap_1.sector,
                typeConstruction: contentMap_1.typeConstruction,
                propertyAddress: contentMap_1.propertyAddress,
                coverageNotes: contentMap_1.coverageNotes,
                typeProperty: contentMap_1.typeProperty,
                buildingValue: formatToTwoDecimals(contentMap_1.buildingValue),
                merchandiseValue: formatToTwoDecimals(contentMap_1.merchandiseValue),
                furnitureValue: formatToTwoDecimals(contentMap_1.furnitureValue),
                totalInsuredValue: formatToTwoDecimals(contentMap_1.transitValue),
            });
            if (contentMap_1.ownerName ||
                contentMap_1.businessShift ||
                contentMap_1.typeConstruction ||
                contentMap_1.propertyTypeId ||
                contentMap_1.address ||
                contentMap_1.constructionTypeName) {
                var businessTypeName = ((_b = businessType.find(function (item) { return item.id === contentMap_1.propertyTypeId; })) === null || _b === void 0 ? void 0 : _b.name) ||
                    contentMap_1.propertyTypeId ||
                    "";
                var businessShiftName = ((_c = businessShift.find(function (item) { return item.id === contentMap_1.businessShift; })) === null || _c === void 0 ? void 0 : _c.name) ||
                    contentMap_1.businessShift ||
                    "";
                var typeConstructionName = ((_d = typeConstruction.find(function (item) { return item.id === contentMap_1.typeConstruction; })) === null || _d === void 0 ? void 0 : _d.name) ||
                    contentMap_1.typeConstruction ||
                    "";
                var propertyData = {
                    id: 1,
                    ownerName: contentMap_1.ownerName || "",
                    propertyTypeId: businessTypeName,
                    businessShift: businessShiftName,
                    typeConstruction: typeConstructionName,
                    typeConstructionName: contentMap_1.constructionTypeName || "",
                    propertyAddress: contentMap_1.address || "",
                };
                setRowsProperties([propertyData]);
            }
        }
    }, [responseOneQuote, businessType, businessShift, typeConstruction]);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (responseCertificateQuote && ((_a = responseCertificateQuote.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var urlC = (_b = responseCertificateQuote.data[0]) === null || _b === void 0 ? void 0 : _b.url;
            if (urlC) {
                setUrlDocument(urlC);
                setNameDocument((_c = responseCertificateQuote.data[0]) === null || _c === void 0 ? void 0 : _c.title);
                setopenModalPdfViewer(true);
            }
            setTriggerCertificate(false);
            dispatch(certificateQuoteClearData());
        }
        else if (responseCertificateQuote &&
            ((_d = responseCertificateQuote.data) === null || _d === void 0 ? void 0 : _d.length) === 0) {
            setTriggerCertificate(false);
            showToastSuccessMessage("No se encontro ningun documento adjunto.", typeAlert.warning, setSeeToast);
            dispatch(certificateQuoteClearData());
        }
    }, [responseCertificateQuote]);
    // determina con que servicio iniciar el formulario de negocio
    useEffect(function () {
        if (planName) {
            var isCommerceValue_1 = planName.toLowerCase().includes("comercio");
            setIsCommerce(isCommerceValue_1);
            setDataFormBusiness(function (prev) { return (__assign(__assign({}, prev), { propertyTypeId: isCommerceValue_1 ? "1" : "2" })); });
        }
    }, [planName]);
    useEffect(function () {
        // Solo setear el país una vez cuando listCountries se cargue por primera vez
        if (listCountries.length > 0 && !countryInitializedRef.current) {
            var countryId_1 = getLogin().countryId || "";
            if (countryId_1) {
                setDataFormInsuranceSp(function (prev) { return (__assign(__assign({}, prev), { country: countryId_1 })); });
                countryInitializedRef.current = true;
            }
        }
    }, [listCountries]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169;
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            setProvinceId((_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.province.id);
            setTowId((_b = responseOneQuote.data) === null || _b === void 0 ? void 0 : _b.municipality.id);
            setSectorId((_c = responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.district.id);
            setPlanCode(((_d = responseOneQuote.data) === null || _d === void 0 ? void 0 : _d.planId.code) || "");
            setProductCode(((_e = responseOneQuote.data) === null || _e === void 0 ? void 0 : _e.productId.code) || "");
            setPersonQuoteId((_f = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _f === void 0 ? void 0 : _f.personId);
            setQuoteId((_g = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _g === void 0 ? void 0 : _g.id);
            setPlanId((_j = (_h = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _h === void 0 ? void 0 : _h.planId) === null || _j === void 0 ? void 0 : _j.id);
            setCoverTypeId((_l = (_k = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _k === void 0 ? void 0 : _k.coverType) === null || _l === void 0 ? void 0 : _l.id);
            setTriggerCatalogInsurance(true);
            setCampaignId((_o = (_m = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _m === void 0 ? void 0 : _m.campaignId) === null || _o === void 0 ? void 0 : _o.id);
            setCatalogPaymentMode((_q = (_p = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _p === void 0 ? void 0 : _p.catalogPaymentMode) === null || _q === void 0 ? void 0 : _q.id);
            var currentStatusQuote = (_s = (_r = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _r === void 0 ? void 0 : _r.catalogStatusQuote) === null || _s === void 0 ? void 0 : _s.description;
            var quoteStatus_1 = currentStatusQuote === null || currentStatusQuote === void 0 ? void 0 : currentStatusQuote.toLowerCase();
            // Logica para mostrar o no los ducumentos de descarga
            var shouldShowDownloads = (function () {
                // en el flujo de venta nuca se muestra
                if (id === undefined || isQuoteType)
                    return false;
                if (downloadsStatusDenyList.length > 0 && !downloadsStatusDenyList.includes(quoteStatus_1)) {
                    return true;
                }
                // Emitida siempre se muestra
                if (quoteStatus_1 === "emitida")
                    return true;
                // Cotizada no se muestra
                if (quoteStatus_1 === "cotizada")
                    return false;
                // Cancelada solo es es acap no se muestra
                if (quoteStatus_1 === "cancelada")
                    return !isAcapCompany;
                return false;
            })();
            //Set show payment tab by quote status if actionflag exist
            setHideTabPaymentInfo(!(isQuote === "false"));
            if (isThereTabPaymentStatusAllowList) {
                if (showTabPaymentStatusAllowList.includes(quoteStatus_1)) {
                    setHideTabPaymentInfo(false);
                }
                else {
                    setHideTabPaymentInfo(true);
                }
            }
            setShowDownloads(shouldShowDownloads);
            setPolicyId((_u = (_t = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _t === void 0 ? void 0 : _t.policyId) === null || _u === void 0 ? void 0 : _u.id);
            // Update paymentModelSelected with the catalogPaymentMode from quote
            if ((_v = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _v === void 0 ? void 0 : _v.catalogPaymentMode) {
                var selectedPaymentMode = {
                    id: responseOneQuote.data.catalogPaymentMode.id,
                    name: responseOneQuote.data.catalogPaymentMode.description,
                    value: responseOneQuote.data.catalogPaymentMode.code ||
                        responseOneQuote.data.catalogPaymentMode.id,
                    label: responseOneQuote.data.catalogPaymentMode.description,
                };
                setPaymentModelSelected(selectedPaymentMode);
                // Set period from quote data
                setPeriod(responseOneQuote.data.catalogPaymentMode.description);
                // Update paymentMode array to mark the correct option as default
                if (paymentMode.length > 0) {
                    var updatedPaymentMode = paymentMode.map(function (mode) { return (__assign(__assign({}, mode), { default: mode.id === responseOneQuote.data.catalogPaymentMode.id })); });
                    setPaymentMode(updatedPaymentMode);
                }
            }
            setCatalogStatusQuote((_x = (_w = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _w === void 0 ? void 0 : _w.catalogStatusQuote) === null || _x === void 0 ? void 0 : _x.id);
            setBranchId((_y = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _y === void 0 ? void 0 : _y.branch);
            setPlanName((_0 = (_z = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _z === void 0 ? void 0 : _z.planId) === null || _0 === void 0 ? void 0 : _0.name);
            // getInsuredBeneficiary();
            var gender = listGenders.find(function (g) { var _a, _b; return g.id === ((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogGender) === null || _b === void 0 ? void 0 : _b.id); });
            var HideMarriedName = (gender === null || gender === void 0 ? void 0 : gender.name) === "Femenino" ? false : true;
            setHideMarriedName(HideMarriedName);
            /*date = formattedDate(date);*/
            //Province
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level1,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            //Municipality
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level2,
                parentRegionId: (_2 = (_1 = responseOneQuote.data) === null || _1 === void 0 ? void 0 : _1.municipality) === null || _2 === void 0 ? void 0 : _2.parentRegionId,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            //District
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level3,
                parentRegionId: (_4 = (_3 = responseOneQuote.data) === null || _3 === void 0 ? void 0 : _3.district) === null || _4 === void 0 ? void 0 : _4.parentRegionId,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            var status = (_6 = (_5 = responseOneQuote.data) === null || _5 === void 0 ? void 0 : _5.catalogStatusQuote) === null || _6 === void 0 ? void 0 : _6.description;
            if (status == "Cancelada") {
                status = "Fecha de cancelación";
            }
            else if (status == "Emitida") {
                status = "Fecha de emisión";
            }
            else if (status == "Expirada") {
                status = "Fecha de expiración";
            }
            else {
                status = "Fecha de cotización";
            }
            var date = ((_8 = (_7 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _7 === void 0 ? void 0 : _7.policyId) === null || _8 === void 0 ? void 0 : _8.effectiveFrom) ||
                ((_9 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _9 === void 0 ? void 0 : _9.creationDate);
            var nextYearDate = undefined;
            var originalDate = void 0;
            if (date) {
                var originalDate_1 = new Date(date);
                originalDate_1.setFullYear(originalDate_1.getFullYear() + 1);
                nextYearDate = formattedDate(originalDate_1.toISOString());
                nextYearDate = originalDate_1.toISOString();
            }
            setDataForm({
                DocumentNumber: formatDocument(responseOneQuote && ((_10 = responseOneQuote.data) === null || _10 === void 0 ? void 0 : _10.numberId)),
                IdType: ((_12 = (_11 = responseOneQuote.data) === null || _11 === void 0 ? void 0 : _11.identificationTypeId) === null || _12 === void 0 ? void 0 : _12.id)
                    ? (_14 = (_13 = responseOneQuote.data) === null || _13 === void 0 ? void 0 : _13.identificationTypeId) === null || _14 === void 0 ? void 0 : _14.id
                    : "",
                Type: responseOneQuote &&
                    ((_16 = (_15 = responseOneQuote.data) === null || _15 === void 0 ? void 0 : _15.identificationTypeId) === null || _16 === void 0 ? void 0 : _16.description),
                QuoteNumber: ((_17 = responseOneQuote.data) === null || _17 === void 0 ? void 0 : _17.policyId)
                    ? (_18 = responseOneQuote.data) === null || _18 === void 0 ? void 0 : _18.policyId.code
                    : responseOneQuote && ((_19 = responseOneQuote.data) === null || _19 === void 0 ? void 0 : _19.code),
                Name: responseOneQuote && ((_20 = responseOneQuote.data) === null || _20 === void 0 ? void 0 : _20.firstNameA),
                SecondName: responseOneQuote && ((_21 = responseOneQuote.data) === null || _21 === void 0 ? void 0 : _21.firstNameB),
                FirstLastName: responseOneQuote && ((_22 = responseOneQuote.data) === null || _22 === void 0 ? void 0 : _22.lastNameA),
                SecondLastName: responseOneQuote && ((_23 = responseOneQuote.data) === null || _23 === void 0 ? void 0 : _23.lastNameB),
                MarriedSurName: responseOneQuote && ((_24 = responseOneQuote.data) === null || _24 === void 0 ? void 0 : _24.marriedName),
                Birthday: responseOneQuote && ((_25 = responseOneQuote.data) === null || _25 === void 0 ? void 0 : _25.dob),
                Address1: responseOneQuote && ((_26 = responseOneQuote.data) === null || _26 === void 0 ? void 0 : _26.address1),
                Address2: responseOneQuote && ((_27 = responseOneQuote.data) === null || _27 === void 0 ? void 0 : _27.address2),
                PhoneOffice: responseOneQuote && formatPhoneNumber((_28 = responseOneQuote.data) === null || _28 === void 0 ? void 0 : _28.phone2),
                PhoneHome: responseOneQuote && formatPhoneNumber((_29 = responseOneQuote.data) === null || _29 === void 0 ? void 0 : _29.phone1),
                PhoneNumber: responseOneQuote && formatPhoneNumber((_30 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _30 === void 0 ? void 0 : _30.phone3),
                Email: responseOneQuote && ((_31 = responseOneQuote.data) === null || _31 === void 0 ? void 0 : _31.email),
                QuoteStatusName: responseOneQuote &&
                    ((_33 = (_32 = responseOneQuote.data) === null || _32 === void 0 ? void 0 : _32.catalogStatusQuote) === null || _33 === void 0 ? void 0 : _33.description),
                QuoteDate: date,
                effectiveDate: responseOneQuote && ((_34 = responseOneQuote.data) === null || _34 === void 0 ? void 0 : _34.policyId)
                    ? nextYearDate
                    : "",
                PlanTypeName: responseOneQuote && ((_36 = (_35 = responseOneQuote.data) === null || _35 === void 0 ? void 0 : _35.planId) === null || _36 === void 0 ? void 0 : _36.name),
                CampaignName: responseOneQuote && ((_38 = (_37 = responseOneQuote.data) === null || _37 === void 0 ? void 0 : _37.campaignId) === null || _38 === void 0 ? void 0 : _38.name),
                IdTypeName: responseOneQuote &&
                    ((_40 = (_39 = responseOneQuote.data) === null || _39 === void 0 ? void 0 : _39.identificationTypeId) === null || _40 === void 0 ? void 0 : _40.description),
                Gender: responseOneQuote && ((_42 = (_41 = responseOneQuote.data) === null || _41 === void 0 ? void 0 : _41.catalogGender) === null || _42 === void 0 ? void 0 : _42.id),
                Country: responseOneQuote && ((_44 = (_43 = responseOneQuote.data) === null || _43 === void 0 ? void 0 : _43.nationality) === null || _44 === void 0 ? void 0 : _44.id),
                CountryName: responseOneQuote && ((_46 = (_45 = responseOneQuote.data) === null || _45 === void 0 ? void 0 : _45.nationality) === null || _46 === void 0 ? void 0 : _46.name),
                Province: responseOneQuote && ((_48 = (_47 = responseOneQuote.data) === null || _47 === void 0 ? void 0 : _47.province) === null || _48 === void 0 ? void 0 : _48.id),
                ProvinceName: responseOneQuote && ((_50 = (_49 = responseOneQuote.data) === null || _49 === void 0 ? void 0 : _49.province) === null || _50 === void 0 ? void 0 : _50.name),
                TownName: responseOneQuote && ((_52 = (_51 = responseOneQuote.data) === null || _51 === void 0 ? void 0 : _51.municipality) === null || _52 === void 0 ? void 0 : _52.name),
                Town: responseOneQuote && ((_54 = (_53 = responseOneQuote.data) === null || _53 === void 0 ? void 0 : _53.municipality) === null || _54 === void 0 ? void 0 : _54.id),
                Sector: responseOneQuote && ((_56 = (_55 = responseOneQuote.data) === null || _55 === void 0 ? void 0 : _55.district) === null || _56 === void 0 ? void 0 : _56.id),
                SectorName: responseOneQuote && ((_58 = (_57 = responseOneQuote.data) === null || _57 === void 0 ? void 0 : _57.district) === null || _58 === void 0 ? void 0 : _58.name),
                PostalCode: responseOneQuote && ((_59 = responseOneQuote.data) === null || _59 === void 0 ? void 0 : _59.zip),
            });
            //setFormVehicle
            setIdQuoteVehicle((_61 = (_60 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _60 === void 0 ? void 0 : _60.contentMap) === null || _61 === void 0 ? void 0 : _61.idquoteVehicle);
            setProductId((_63 = (_62 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _62 === void 0 ? void 0 : _62.productId) === null || _63 === void 0 ? void 0 : _63.id);
            var carConditionName = void 0;
            switch ((_65 = (_64 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _64 === void 0 ? void 0 : _64.contentMap) === null || _65 === void 0 ? void 0 : _65.condition) {
                case "USED":
                    carConditionName = "Usado";
                    break;
                case "NEW":
                    carConditionName = "Nuevo";
                    break;
            }
            if ((_66 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _66 === void 0 ? void 0 : _66.profileDocuments) {
                var pendingCount = responseOneQuote.data.profileDocuments.filter(function (doc) { return (doc === null || doc === void 0 ? void 0 : doc.status) === "PENDING"; }).length;
                setCountBadge(pendingCount);
                var dataRows = (_68 = (_67 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _67 === void 0 ? void 0 : _67.profileDocuments) === null || _68 === void 0 ? void 0 : _68.map(function (item) {
                    var _a;
                    return ({
                        id: item.id,
                        docType: item.name,
                        state: (function () {
                            switch (item.status) {
                                case "PENDING":
                                    return "Pendiente";
                                case "READY":
                                    return "Listo";
                            }
                        })(),
                        date: "",
                        user: "",
                        documentClientUrl: ((_a = item.document) === null || _a === void 0 ? void 0 : _a.path) || "",
                    });
                });
                setProfileDocumentsRows(dataRows);
            }
            var fuelTypeName = void 0;
            switch ((_70 = (_69 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _69 === void 0 ? void 0 : _69.contentMap) === null || _70 === void 0 ? void 0 : _70.combustion) {
                case "GAS":
                    fuelTypeName = "Gas";
                    break;
                case "ELECTRIC":
                    fuelTypeName = "Eléctrico";
                    break;
                case "DIESEL":
                    fuelTypeName = "Diesel";
                    break;
                case "GASOLINE":
                    fuelTypeName = "Gasolina";
                    break;
            }
            var countChassis = ((_72 = (_71 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _71 === void 0 ? void 0 : _71.contentMap) === null || _72 === void 0 ? void 0 : _72.chassisNumber) || "";
            var isChassisValid = (countChassis === null || countChassis === void 0 ? void 0 : countChassis.length) !== 17;
            setDataFormVehicle({
                carDetails: [
                    {
                        brand: {
                            id: (_75 = (_74 = (_73 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _73 === void 0 ? void 0 : _73.contentMap) === null || _74 === void 0 ? void 0 : _74.brand) === null || _75 === void 0 ? void 0 : _75.id,
                            name: (_78 = (_77 = (_76 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _76 === void 0 ? void 0 : _76.contentMap) === null || _77 === void 0 ? void 0 : _77.brand) === null || _78 === void 0 ? void 0 : _78.name,
                        },
                        model: {
                            id: (_81 = (_80 = (_79 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _79 === void 0 ? void 0 : _79.contentMap) === null || _80 === void 0 ? void 0 : _80.model) === null || _81 === void 0 ? void 0 : _81.id,
                            name: (_84 = (_83 = (_82 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _82 === void 0 ? void 0 : _82.contentMap) === null || _83 === void 0 ? void 0 : _83.model) === null || _84 === void 0 ? void 0 : _84.name,
                        },
                        version: {
                            id: (_87 = (_86 = (_85 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _85 === void 0 ? void 0 : _85.contentMap) === null || _86 === void 0 ? void 0 : _86.version) === null || _87 === void 0 ? void 0 : _87.id,
                            name: (_90 = (_89 = (_88 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _88 === void 0 ? void 0 : _88.contentMap) === null || _89 === void 0 ? void 0 : _89.version) === null || _90 === void 0 ? void 0 : _90.name,
                        },
                        class: {
                            id: (_93 = (_92 = (_91 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _91 === void 0 ? void 0 : _91.contentMap) === null || _92 === void 0 ? void 0 : _92.class) === null || _93 === void 0 ? void 0 : _93.id,
                            name: (_96 = (_95 = (_94 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _94 === void 0 ? void 0 : _94.contentMap) === null || _95 === void 0 ? void 0 : _95.class) === null || _96 === void 0 ? void 0 : _96.name,
                        },
                        type: {
                            id: (_99 = (_98 = (_97 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _97 === void 0 ? void 0 : _97.contentMap) === null || _98 === void 0 ? void 0 : _98.type) === null || _99 === void 0 ? void 0 : _99.id,
                            name: (_102 = (_101 = (_100 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _100 === void 0 ? void 0 : _100.contentMap) === null || _101 === void 0 ? void 0 : _101.type) === null || _102 === void 0 ? void 0 : _102.name,
                        },
                        weight: (_104 = (_103 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _103 === void 0 ? void 0 : _103.contentMap) === null || _104 === void 0 ? void 0 : _104.weight,
                        tonnage: (_106 = (_105 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _105 === void 0 ? void 0 : _105.contentMap) === null || _106 === void 0 ? void 0 : _106.tonnage,
                        passengerCant: (_108 = (_107 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _107 === void 0 ? void 0 : _107.contentMap) === null || _108 === void 0 ? void 0 : _108.passengerCant,
                    },
                ],
                year: (_110 = (_109 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _109 === void 0 ? void 0 : _109.contentMap) === null || _110 === void 0 ? void 0 : _110.year,
                carColor: [
                    {
                        id: (_113 = (_112 = (_111 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _111 === void 0 ? void 0 : _111.contentMap) === null || _112 === void 0 ? void 0 : _112.colors) === null || _113 === void 0 ? void 0 : _113.id,
                        name: (_116 = (_115 = (_114 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _114 === void 0 ? void 0 : _114.contentMap) === null || _115 === void 0 ? void 0 : _115.colors) === null || _116 === void 0 ? void 0 : _116.name,
                    },
                ],
                chassisNumber: (_118 = (_117 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _117 === void 0 ? void 0 : _117.contentMap) === null || _118 === void 0 ? void 0 : _118.chassisNumber,
                shortChassis: isChassisValid,
                price: (_120 = (_119 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _119 === void 0 ? void 0 : _119.contentMap) === null || _120 === void 0 ? void 0 : _120.deductibleTypeId,
                numberCylinders: [
                    {
                        id: (_122 = (_121 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _121 === void 0 ? void 0 : _121.contentMap) === null || _122 === void 0 ? void 0 : _122.cylinders,
                        name: (_124 = (_123 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _123 === void 0 ? void 0 : _123.contentMap) === null || _124 === void 0 ? void 0 : _124.cylinders,
                    },
                ],
                fuelType: [
                    {
                        id: (_126 = (_125 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _125 === void 0 ? void 0 : _125.contentMap) === null || _126 === void 0 ? void 0 : _126.combustion,
                        name: fuelTypeName,
                    },
                ],
                registrationNumber: (_128 = (_127 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _127 === void 0 ? void 0 : _127.contentMap) === null || _128 === void 0 ? void 0 : _128.plate,
                carCondition: [
                    {
                        id: (_130 = (_129 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _129 === void 0 ? void 0 : _129.contentMap) === null || _130 === void 0 ? void 0 : _130.condition,
                        name: carConditionName,
                    },
                ],
            });
            //EndFormVehicle
            //setStatementRows
            if (responseOneQuote.data.billing) {
                var dataRows = (_132 = (_131 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _131 === void 0 ? void 0 : _131.billing) === null || _132 === void 0 ? void 0 : _132.map(function (item) { return ({
                    accountName: item.account,
                    amount: "RD$ ".concat(item.amount),
                    paymentDate: newFormattedDate(item.paymentDate),
                    dateExpire: newFormattedDate(item.dateExpire),
                    datePaid: newFormattedDate(item.datePaid),
                    state: (function () {
                        switch (item.statusBilling) {
                            case "GENERATED":
                                return "Generado";
                            case "EMMITED":
                                return "Emitido";
                            case "PAID":
                                return "Pagado";
                            case "CANCELLED":
                                return "Cancelado";
                        }
                    })(),
                }); });
                setStatementRows(dataRows);
            }
            // EndSetStatmentRows
            // if (id) {
            // setPrime(responseOneQuote?.data?.lastPrice?.amount);
            setPrime(((_134 = (_133 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _133 === void 0 ? void 0 : _133.lastPrice) === null || _134 === void 0 ? void 0 : _134.amount)
                ? formatToTwoDecimals(responseOneQuote.data.lastPrice.amount)
                : "0.00");
            callDispatchPageActionFlags((_136 = (_135 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _135 === void 0 ? void 0 : _135.planId) === null || _136 === void 0 ? void 0 : _136.projectId);
            // Update projectId from the quote response
            if ((_138 = (_137 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _137 === void 0 ? void 0 : _137.planId) === null || _138 === void 0 ? void 0 : _138.projectId) {
                setProjectId(responseOneQuote.data.planId.projectId);
            }
            if (id) {
                setLocalStorage(responseOneQuote.data, responseOneProject);
                if (isQuote === "false") {
                    setBreadCrumbs([]);
                }
                else {
                    setBreadCrumbs(stepProgress(STEP, true));
                }
                var certs = (_139 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _139 === void 0 ? void 0 : _139.certificates;
                //Get the certificates
                if (certs.length > 0) {
                    certs = certs.map(function (c, id) {
                        return {
                            id: c.id,
                            name: c.title,
                            url: c.url,
                        };
                    });
                }
                setCertificates(certs);
                //Get the additional payment info
                if ((responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) && isQuote && isQuote === "false") {
                    var additionalInfo = [];
                    var data = responseOneQuote.data;
                    var lastPrice = data.lastPrice, customerAccount = data.customerAccount, catalogPaymentMode_1 = data.catalogPaymentMode, id_1 = data.id;
                    var amount = (_140 = lastPrice === null || lastPrice === void 0 ? void 0 : lastPrice.amount) !== null && _140 !== void 0 ? _140 : "0.00";
                    var currencySymbol = (lastPrice === null || lastPrice === void 0 ? void 0 : lastPrice.currencySymbol) || "";
                    var formattedAmount = formatToTwoDecimals(amount);
                    additionalInfo.push({
                        id: id_1,
                        accountName: customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountName,
                        accountNumber: customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountNumber,
                        accountType: (_141 = customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountType) === null || _141 === void 0 ? void 0 : _141.description,
                        paymentMode: catalogPaymentMode_1 === null || catalogPaymentMode_1 === void 0 ? void 0 : catalogPaymentMode_1.description,
                        prime: "".concat(currencySymbol, " ").concat(formattedAmount),
                        lastDigits: "N/A",
                    });
                    setRows2(additionalInfo);
                }
            }
            else {
                setRows2([
                    {
                        id: "1",
                        accountName: "N/A",
                        accountNumber: "N/A",
                        accountType: "N/A",
                        paymentMode: "N/A",
                        prime: "N/A",
                        lastDigits: "N/A",
                    },
                ]);
            }
            /*Adiciona al resumen la informacion de vehiculos*/
            switch ((_143 = (_142 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _142 === void 0 ? void 0 : _142.contentMap) === null || _143 === void 0 ? void 0 : _143.condition) {
                case "USED":
                    carConditionName = "Usado";
                    break;
                case "NEW":
                    carConditionName = "Nuevo";
                    break;
            }
            var price = ((_145 = (_144 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _144 === void 0 ? void 0 : _144.lastPrice) === null || _145 === void 0 ? void 0 : _145.currencySymbol) &&
                ((_147 = (_146 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _146 === void 0 ? void 0 : _146.lastPrice) === null || _147 === void 0 ? void 0 : _147.amount)
                ? "".concat((_149 = (_148 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _148 === void 0 ? void 0 : _148.lastPrice) === null || _149 === void 0 ? void 0 : _149.currencySymbol, " ").concat((_151 = (_150 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _150 === void 0 ? void 0 : _150.lastPrice) === null || _151 === void 0 ? void 0 : _151.amount)
                : "RD$ 0.00";
            var baseFilters = [
                {
                    name: "Producto",
                    type: "label",
                    label: (_154 = (_153 = (_152 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _152 === void 0 ? void 0 : _152.productId) === null || _153 === void 0 ? void 0 : _153.description) !== null && _154 !== void 0 ? _154 : "",
                },
                {
                    name: "Plan",
                    type: "label",
                    label: (_157 = (_156 = (_155 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _155 === void 0 ? void 0 : _155.planId) === null || _156 === void 0 ? void 0 : _156.name) !== null && _157 !== void 0 ? _157 : "",
                    showChangeButton: true,
                },
                {
                    name: "Modalidad de Pago",
                    type: "label",
                    label: (_160 = (_159 = (_158 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _158 === void 0 ? void 0 : _158.catalogPaymentMode) === null || _159 === void 0 ? void 0 : _159.description) !== null && _160 !== void 0 ? _160 : "",
                    showChangeButton: true,
                },
                {
                    name: "Tipo de Cobertura",
                    type: "label",
                    label: (_166 = (_163 = (_162 = (_161 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _161 === void 0 ? void 0 : _161.coverType) === null || _162 === void 0 ? void 0 : _162.description) !== null && _163 !== void 0 ? _163 : (_165 = (_164 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _164 === void 0 ? void 0 : _164.coverType) === null || _165 === void 0 ? void 0 : _165.name) !== null && _166 !== void 0 ? _166 : "",
                    showChangeButton: true,
                },
                {
                    name: "Campaña",
                    type: "label",
                    label: (_169 = (_168 = (_167 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _167 === void 0 ? void 0 : _167.campaignId) === null || _168 === void 0 ? void 0 : _168.name) !== null && _169 !== void 0 ? _169 : "",
                },
            ];
            var filtersPlan = [
                {
                    name: "Prima",
                    type: "label",
                    label: price,
                },
            ];
            setDefaultFilters(isQuote === "false" ? __spreadArray(__spreadArray([], baseFilters, true), filtersPlan, true) : baseFilters);
        }
        dispatch(projectOneClearData());
    }, [responseOneQuote, downloadsStatusDenyList, isThereTabPaymentStatusAllowList]);
    // Load plans when quote + projectId exist (payment mode from quote, state, or plan-step localStorage; see callDispatchPlan)
    useEffect(function () {
        if ((responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) && projectId) {
            callDispatchPlan(null, null);
        }
    }, [responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data, projectId, paymentModelSelected === null || paymentModelSelected === void 0 ? void 0 : paymentModelSelected.id, catalogPaymentMode, callDispatchPlan]);
    useEffect(function () {
        var _a, _b, _c;
        if (responseOneProject) {
            setSalesFlow(responseOneProject.salesFlow);
            setProductType((_c = (_b = (_a = responseOneProject.salesFlow) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.navigation) === null || _c === void 0 ? void 0 : _c.productType);
            if (idProject) {
                // localStorageService.setStepStored({
                //   id: "",
                //   name: "",
                //   step: Steps.insurance,
                //   completed: true,
                //   flow: responseOneProject.salesFlow,
                // });
            }
        }
    }, [responseOneProject]);
    useEffect(function () {
        var _a, _b;
        if (responseGetCatalogBeneficiary && (responseGetCatalogBeneficiary === null || responseGetCatalogBeneficiary === void 0 ? void 0 : responseGetCatalogBeneficiary.data)) {
            var beneficiaryList_1 = [];
            (_a = responseGetCatalogBeneficiary.data) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                beneficiaryList_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                });
            });
            setBeneficiaryType(beneficiaryList_1);
            setDataFormBeneficiary(__assign(__assign({}, dataFormBeneficiary), { idTypeInsured: (_b = beneficiaryList_1[0].value) !== null && _b !== void 0 ? _b : "" }));
        }
    }, [responseGetCatalogBeneficiary]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (responseGetCatalogInsurance && (responseGetCatalogInsurance === null || responseGetCatalogInsurance === void 0 ? void 0 : responseGetCatalogInsurance.data)) {
            var insuranceList_1 = [];
            (_a = responseGetCatalogInsurance.data) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                var _a;
                insuranceList_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                    code: (_a = item.code) !== null && _a !== void 0 ? _a : "",
                });
            });
            setInsuredType(insuranceList_1);
            setDataFormInsurance(__assign(__assign({}, dataFormInsurance), { idInsuredType: (_b = insuranceList_1[0].value) !== null && _b !== void 0 ? _b : "" }));
            // Buscar el elemento que contenga "Titular" o "titular"
            var titularItem = insuranceList_1.find(function (item) {
                return item.name.toLowerCase().includes("titular");
            });
            setInsuranceType((_d = (_c = titularItem === null || titularItem === void 0 ? void 0 : titularItem.value) !== null && _c !== void 0 ? _c : insuranceList_1[0].value) !== null && _d !== void 0 ? _d : "");
            setDataFormInsuranceSp(__assign(__assign({}, dataFormInsuranceSp), { idInsuredType: (_f = (_e = titularItem === null || titularItem === void 0 ? void 0 : titularItem.value) !== null && _e !== void 0 ? _e : insuranceList_1[0].value) !== null && _f !== void 0 ? _f : "" }));
        }
    }, [responseGetCatalogInsurance]);
    useEffect(function () {
        var _a, _b, _c;
        if (responsePlans) {
            var dataST_1 = [];
            // Prioritize payment mode from quote data
            var paymentModeFromQuote = (_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.description;
            var pm = (_c = localStorageService.getStepStored().steps[Steps.plan]
                .paymentModeSelected) === null || _c === void 0 ? void 0 : _c.name;
            // Use quote data first, then period state, then localStorage
            var paymentPeriod_1 = paymentModeFromQuote || period || pm;
            if (period === undefined && paymentPeriod_1) {
                setPeriod(paymentPeriod_1);
            }
            responsePlans.map(function (item) {
                var _a;
                dataST_1.push({
                    id: item.id,
                    name: item.name ? item.name.replace(/"/g, "") : "",
                    logo: item.sponsorLogoUrl && item.sponsorLogoUrl,
                    backgroundColor: "#ffffff",
                    currency: "$",
                    itemsValue: [],
                    option: setCoverTypeStorybook(item.coverTypes ? item.coverTypes : []),
                    period: paymentPeriod_1,
                    price: item.price ? (_a = item.price) === null || _a === void 0 ? void 0 : _a.amount : "0",
                    textColor: "#3A56A1",
                });
            });
            setPlanData(__assign(__assign({}, plan), { data: dataST_1 }));
        }
    }, [responsePlans, responseOneQuote]);
    useEffect(function () {
        if (listIdentificationType.length > 0 &&
            listGenders.length > 0 &&
            listCountries.length > 0 &&
            listRegionLevel1.length > 0 &&
            listRegionLevel2.length > 0 &&
            listRegionLevel3.length > 0 &&
            !showComponent) {
            setShowComponent(true);
        }
    }, [
        listIdentificationType,
        listGenders,
        listCountries,
        listRegionLevel1,
        listRegionLevel2,
        listRegionLevel3,
    ]);
    useEffect(function () {
        if (responsePageActionFlags) {
            lsPageActionFlags.setPageActionFlagsStored(responsePageActionFlags);
            setActionFlags(responsePageActionFlags);
            getActionFlags();
            dispatch(pageActionFlagsClearData());
            //default set tab show states
            setIsThereShowTabPaymentStatusAllowList(false);
            setShowTabPaymentStatusAllowList([]);
            setHideTabDocumentClient(isApapAuto && (isQuote === "true" || isQuote === undefined));
            responsePageActionFlags === null || responsePageActionFlags === void 0 ? void 0 : responsePageActionFlags.forEach(function (actionFlag) {
                if (actionFlag.name === "afy-show-plan-travel-range-info") {
                    setIsTravelInsurance(true);
                }
                if (actionFlag.name === "afy-confirm-data-downloads-status-denylist") {
                    var statusdenylist_1 = JSON.parse(actionFlag.value);
                    setDownloadsStatusDenyList(function (prev) {
                        if (JSON.stringify(prev) === JSON.stringify(statusdenylist_1))
                            return prev;
                        return statusdenylist_1;
                    });
                }
                if (actionFlag.name === "afy-confirm-data-show-tab-payment-status-allowlist") {
                    setIsThereShowTabPaymentStatusAllowList(true);
                    var statusallowlist_1 = JSON.parse(actionFlag.value);
                    setShowTabPaymentStatusAllowList(function (prev) {
                        if (JSON.stringify(prev) === JSON.stringify(statusallowlist_1))
                            return prev;
                        return statusallowlist_1;
                    });
                }
                if (actionFlag.name === "afy-confirm-data-show-tab-client-documents") {
                    setHideTabDocumentClient(actionFlag.value !== "true");
                }
            });
        }
    }, [responsePageActionFlags]);
    useEffect(function () {
        if (responsePatchBeneficiary && responsePatchBeneficiary.data) {
            showToastSuccessMessage("Beneficiario actualizado con éxito.", typeAlert.success, setSeeToast);
            setOpenModal(false);
            dispatch(patchBeneficiaryClearData());
            getInsuredBeneficiary();
        }
    }, [responsePatchBeneficiary]);
    useEffect(function () {
        var _a;
        // responsePatchQuote starts as null, becomes `true` while loading,
        // and becomes the payload (with .data) on success. Only react on success.
        if (responsePatchQuote &&
            responsePatchQuote !== true &&
            (responsePatchQuote === null || responsePatchQuote === void 0 ? void 0 : responsePatchQuote.data)) {
            showToastSuccessMessage("Cotización actualizada con éxito.", typeAlert.success, setSeeToast);
            dispatch(patchQuoteClearData());
            callQuoteOne((_a = id !== null && id !== void 0 ? id : quoteId) !== null && _a !== void 0 ? _a : "");
        }
    }, [responsePatchQuote]);
    useEffect(function () {
        if (errorPatchQuote) {
            showToastSuccessMessage("No se pudo actualizar la cotización.", typeAlert.error, setSeeToast);
            dispatch(patchQuoteClearData());
        }
    }, [errorPatchQuote]);
    useEffect(function () {
        if (responsePatchInsured && responsePatchInsured.data) {
            showToastSuccessMessage("Asegurado actualizado con éxito.", typeAlert.success, setSeeToast);
            setOpenModal(false);
            setOpenModalAddInsurance(false);
            // dispatch(person({ enable: true, page: 1, limit: 1000 }));
            dispatch(patchInsuredClearData());
            getInsuredBeneficiary();
        }
    }, [responsePatchInsured]);
    useEffect(function () {
        if (responsePostInsured) {
            showToastSuccessMessage("Asegurado agregado con éxito.", typeAlert.success, setSeeToast);
            dispatch(postInsuredClearData());
            setOpenModal(false);
            setOpenModalAddInsurance(false);
            dispatch(patchInsuredClearData());
            getInsuredBeneficiary();
        }
    }, [responsePostInsured]);
    useEffect(function () {
        if (responseUpdatePerson === null || responseUpdatePerson === void 0 ? void 0 : responseUpdatePerson.data) {
            showToastSuccessMessage("Agregado con éxito.", typeAlert.success, setSeeToast);
            // if (id !== undefined) {
            dispatch(quoteClearData());
            dispatch(quoteOne({ id: id !== null && id !== void 0 ? id : quoteId, fullBody: true }));
            // } else {
            //   dispatch(
            //     quoteOne({
            //       id: quoteId ?? id,
            //       fullBody: true,
            //     }),
            //   );
            // }
        }
    }, [responseUpdatePerson]);
    useEffect(function () {
        if (responseBenefit && (responseBenefit === null || responseBenefit === void 0 ? void 0 : responseBenefit.data)) {
            showToastSuccessMessage("Beneficiario agregado con éxito.", typeAlert.success, setSeeToast);
            setOpenModalBeneficiary(false);
            getInsuredBeneficiary();
            dispatch(benefitClearData());
        }
    }, [responseBenefit]);
    useEffect(function () {
        if (responsePlan && responsePlan.data) {
            /* Payment modes are now loaded from dedicated API - see useEffect for responsePaymentMode */
            /* Filtrar por coverage type */
            var result = filterData(responsePlan.data, "type", catalogConst.CATALOG_BENEFICIARY_TYPE);
            if (result.length > 0) {
                setCoverageType(result);
            }
            /* Filtrar por insured type */
            result = filterData(responsePlan.data, "type", catalogConst.CATALOG_INSURED_TYPE);
            // if (result.length > 0) {
            //   setInsuredType(result);
            //   setDataFormInsurance({
            //     ...dataFormInsurance,
            //     idTypeInsured: result[0].value ?? "",
            //   });
            // }
            /* Filtrar por beneficiary type */
            result = filterData(responsePlan.data, "type", catalogConst.CATALOG_BENEFICIARY_TYPE);
            // if (result.length > 0) {
            //   setBeneficiaryType(result);
            //   setDataFormBeneficiary({
            //     ...dataFormBeneficiary,
            //     idTypeInsured: result[0].value ?? "",
            //   });
            // }
        }
    }, [responsePlan]);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (responseIdentificationType &&
            ((_a = responseIdentificationType.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var idf_1 = [];
            (_b = responseIdentificationType.data) === null || _b === void 0 ? void 0 : _b.map(function (item) {
                idf_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                });
            });
            setListIdentificationType(idf_1);
            setDataFormBeneficiary(__assign(__assign({}, dataFormBeneficiary), { IdType: (_c = idf_1[0].value) !== null && _c !== void 0 ? _c : "" }));
            setDataFormInsurance(__assign(__assign({}, dataFormInsurance), { IdType: (_d = idf_1[0].value) !== null && _d !== void 0 ? _d : "" }));
            setDataFormInsuranceSp(__assign(__assign({}, dataFormInsuranceSp), { idType: (_e = idf_1[0].value) !== null && _e !== void 0 ? _e : "" }));
        }
        else {
            //navigate("/customerForm");
        }
    }, [responseIdentificationType]);
    useEffect(function () {
        var _a, _b;
        if (responseCatalogGender && ((_a = responseCatalogGender.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var data = (_b = responseCatalogGender.data) === null || _b === void 0 ? void 0 : _b.map(function (gender) {
                return {
                    id: gender.id,
                    value: gender.id,
                    name: gender.description,
                };
            });
            setListGenders(data);
        }
        else {
            //navigate("/customerForm");
        }
    }, [responseCatalogGender]);
    useEffect(function () {
        var _a, _b;
        if (responseCountries && ((_a = responseCountries.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var data = (_b = responseCountries.data) === null || _b === void 0 ? void 0 : _b.map(function (country) {
                return {
                    id: country.id,
                    value: country.id,
                    name: country.description,
                };
            });
            setListCountries(data);
        }
        else {
            //navigate("/customerForm");
        }
    }, [responseCountries]);
    useEffect(function () {
        var _a;
        if (responseRegion && (responseRegion === null || responseRegion === void 0 ? void 0 : responseRegion.data)) {
            var data = (_a = responseRegion.data) === null || _a === void 0 ? void 0 : _a.map(function (region) {
                return {
                    id: region.id,
                    value: region.id,
                    name: region.name,
                };
            });
            data.unshift({ id: "-1", value: "-1", name: " " });
            if (responseRegion.level === level1) {
                setListRegionLevel1(data);
            }
            else if (responseRegion.level === level2) {
                if (data.length > 0) {
                    setListRegionLevel2(data);
                }
                else {
                    setListRegionLevel2([{ id: "-1", value: "-1", name: " " }]);
                }
            }
            else if (responseRegion.level === level3) {
                if (data.length > 0) {
                    setListRegionLevel3(data);
                }
                else {
                    setListRegionLevel3([{ id: "-1", value: "-1", name: " " }]);
                }
            }
        }
    }, [responseRegion]);
    useEffect(function () {
        if (responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data) {
            setBeneficiaryStorybook(responseBeneficiary.data);
        }
    }, [responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data]);
    useEffect(function () {
        if (responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data) {
            setInsuranceStorybook(responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data);
            setSessionData(responseInsured);
        }
    }, [responseInsured]);
    useEffect(function () {
        if (actionFlags.length > 0) {
            getActionFlags();
        }
    }, [actionFlags]);
    // Override Prima in localStorage summary with contentMap.premium when travel insurance
    useEffect(function () {
        var _a, _b;
        if (isTravelInsurance &&
            ((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.contentMap) === null || _b === void 0 ? void 0 : _b.premium) != null) {
            addToSummary([
                {
                    label: "Prima",
                    value: "USD ".concat(responseOneQuote.data.contentMap.premium),
                },
            ]);
        }
    }, [isTravelInsurance, (_q = (_p = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _p === void 0 ? void 0 : _p.contentMap) === null || _q === void 0 ? void 0 : _q.premium]);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (!((_a = summary === null || summary === void 0 ? void 0 : summary.data) === null || _a === void 0 ? void 0 : _a.length)) {
            setFilters(defaultFilters);
            return;
        }
        var byLabel = Object.fromEntries(summary.data.map(function (i) { return [i.label, i.value]; }));
        // Orden grupo deseado
        var header = ["Documento", "No. de cotización"];
        var cliente = ["Nombres", "Apellidos"];
        var used = new Set(__spreadArray(__spreadArray([], header, true), cliente, true));
        var producto = summary.data.filter(function (i) { return !used.has(i.label); });
        var out = __spreadArray([
            {
                name: "Número de cotización",
                label: (_b = byLabel["No. de cotización"]) !== null && _b !== void 0 ? _b : "-",
                type: "label",
            },
            {
                name: "Número de documento",
                label: (_c = byLabel["Documento"]) !== null && _c !== void 0 ? _c : "-",
                type: "label",
            },
            // Subtítulo cliente
            {
                name: "Datos del cliente",
                label: "Datos del cliente",
                type: "subtitle",
            },
            { name: "Nombres", label: (_d = byLabel["Nombres"]) !== null && _d !== void 0 ? _d : "-", type: "label" },
            { name: "Apellidos", label: (_e = byLabel["Apellidos"]) !== null && _e !== void 0 ? _e : "-", type: "label" },
            // Subtítulo producto
            {
                name: "Datos del producto",
                label: "Datos del producto",
                type: "subtitle",
            }
        ], producto.map(function (e) {
            var _a, _b;
            var labelValue = e.value;
            if (e.label === "Prima") {
                if (isTravelInsurance &&
                    ((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.contentMap) === null || _b === void 0 ? void 0 : _b.premium) != null) {
                    labelValue = "USD ".concat(responseOneQuote.data.contentMap.premium);
                }
                else {
                    labelValue = prime || e.value;
                }
            }
            var name = e.label;
            var showChangeButton = isQuoteType &&
                (name === "Plan" ||
                    name === "Modalidad de Pago" ||
                    name === "Tipo de Cobertura");
            return __assign({ name: name, label: labelValue, type: "label" }, (showChangeButton ? { showChangeButton: true } : {}));
        }), true);
        setFilters(out);
    }, [
        summary,
        defaultFilters,
        prime,
        isTravelInsurance,
        (_s = (_r = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _r === void 0 ? void 0 : _r.contentMap) === null || _s === void 0 ? void 0 : _s.premium,
    ]);
    useEffect(function () {
        if (responsePersonByDocument && responsePersonByDocument.length > 0) {
            var dataPerson = responsePersonByDocument[0];
            var updatedDataFormPerson = updateDataFormPerson(dataPerson, isInsurance ? dataFormInsurance : dataFormBeneficiary);
            if (isInsurance) {
                setDataFormInsurance(updatedDataFormPerson);
            }
            else {
                setDataFormBeneficiary(updatedDataFormPerson);
            }
            setTrigger(false);
            dispatch(personByDocumentClearData());
        }
        if ((responsePersonByDocument === null || responsePersonByDocument === void 0 ? void 0 : responsePersonByDocument.length) === 0) {
            if (isInsurance) {
                setDataFormInsurance({
                    Name: "",
                    SecondName: "",
                    LastNameA: "",
                    LastNameB: "",
                    marriedName: "",
                    Birthday: "",
                    PhoneNumber: "",
                });
            }
            else {
                setDataFormBeneficiary({
                    Name: "",
                    SecondName: "",
                    LastNameA: "",
                    LastNameB: "",
                    marriedName: "",
                    Birthday: "",
                    PhoneNumber: "",
                });
            }
            dispatch(personByDocumentClearData());
        }
    }, [responsePersonByDocument, isInsurance, trigger]);
    useEffect(function () {
        setUploadTrigger(false);
        setOpenDrawerUpload(false);
        dispatch(postQuoteUploadDocumentClearData());
        if (id !== undefined) {
            dispatch(quoteClearData());
            callQuoteOne(id);
        }
        else {
            callQuoteOne(quoteId);
        }
    }, [responseUploadDocuments]);
    var deleteInsured = React.useCallback(function (params) {
        var _a;
        var insuredId = (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.id;
        if (!insuredId)
            return;
        dispatch(deleteInsuredAction({
            id: insuredId,
            body: { force: false },
        }));
    }, [dispatch]);
    useEffect(function () {
        var _a;
        if (!responseDeleteInsured && !errorDeleteInsured)
            return;
        if (responseDeleteInsured) {
            dispatch(insured({
                enable: true,
                page: 1,
                limit: 100,
                quoteId: quoteId ? quoteId : id,
            }));
            setSeeToast({
                show: true,
                message: "Asegurado eliminado correctamente.",
                type: typeAlert.success,
            });
        }
        if (errorDeleteInsured) {
            setSeeToast({
                show: true,
                message: (_a = errorDeleteInsured === null || errorDeleteInsured === void 0 ? void 0 : errorDeleteInsured.message) !== null && _a !== void 0 ? _a : "No se pudo eliminar el asegurado. Intente nuevamente.",
                type: typeAlert.error,
            });
        }
        dispatch(deleteInsuredClearData());
    }, [responseDeleteInsured, errorDeleteInsured]);
    var columnsInsurance = Tab1Columns(editInsured, deleteInsured, canEditInsured, rows);
    var columnsBeneficiary = Tab2Columns(editBeneficiary, canEditBeneficiary);
    var callGetInsuredBeneficiary = function (quoteId) {
        var id_ = quoteId;
        if (id_) {
            if (!(responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data) && !(responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data)) {
                dispatch(getBeneficiary({
                    enable: true,
                    page: 1,
                    limit: 100,
                    quoteId: id_,
                }));
                dispatch(insured({
                    enable: true,
                    page: 1,
                    limit: 100,
                    quoteId: id_,
                }));
            }
        }
    };
    // Passenger Download Modal State
    var _150 = useState(false), openPassengerModal = _150[0], setOpenPassengerModal = _150[1];
    var _151 = useState(false), openModalAddPassenger = _151[0], setOpenModalAddPassenger = _151[1];
    var _152 = useState(""), selectedQuoteId = _152[0], setSelectedQuoteId = _152[1];
    var _153 = useState(null), editingPassengerId = _153[0], setEditingPassengerId = _153[1];
    var _154 = useState(null), editingPassengerData = _154[0], setEditingPassengerData = _154[1];
    var handleAddPassanger = function () {
        setEditingPassengerId(null);
        setEditingPassengerData(null);
        setOpenModalAddPassenger(true);
    };
    var onClickPassangerDownload = React.useCallback(function () {
        setSelectedQuoteId(quoteId);
        setOpenPassengerModal(true);
    }, [quoteId]);
    var handlePassengerModalClose = React.useCallback(function () {
        setOpenPassengerModal(false);
        setSelectedQuoteId("");
    }, []);
    var handleOpenPdf = React.useCallback(function (url, name) {
        setUrlDocumentPassenger(url);
        setNameDocumentPassenger(name);
        setOpenModalPassenger(true);
    }, []);
    var _155 = React.useState(false), triggerAddAppointmentAction = _155[0], setTriggerAddAppointmentAction = _155[1];
    var columnsAppointment = TabAppointmentColumns(false, false);
    var columnsAppointmentManager = TabAppointmentManagerColumns(false, false);
    var _156 = useAppointment(quoteId, showTabAppointment), appointmentRows = _156.appointmentRows, appointmentId = _156.appointmentId;
    var _157 = useAppointmentManager(appointmentId, setOpenModalAddAppointmentAction, setTriggerAddAppointmentAction, triggerAddAppointmentAction, showTabAppointmentManager, (_t = lsLogin.getUserLoginStored().user.id) !== null && _t !== void 0 ? _t : "", setSeeToast), appointmentManagerRows = _157.appointmentManagerRows, handleAddAppointmetAction = _157.handleAddAppointmetAction, handleSubmitAppointmentAction = _157.handleSubmitAppointmentAction, formAppointmentActionProps = _157.formAppointmentActionProps, loadingAppointmentActionPatch = _157.loadingAppointmentActionPatch;
    return (_jsxs(React.Fragment, { children: [_jsx(PagesHeader, { titlePage: titleInsured, hideStep: isQuote === "false", steps: steps, completed: isQuote === "false" }), _jsx(ConfirmationHeader, { loading: loadingPostInsured ||
                    loadingUpdatePerson ||
                    loadingOneQuote ||
                    loadingBenefit ||
                    loadingPostInsured ||
                    loadingPatchBeneficiary ||
                    loadingPatchInsured ||
                    loadingPersonByDocument ||
                    loadingOneProject ||
                    loadingBeneficiary ||
                    loading ||
                    loadingPlans ||
                    loadingUpdateQuote ||
                    loadingUploadDocuments ||
                    loadingGetCatalogBeneficiary ||
                    loadingGetCatalogInsurance ||
                    loadingCertificateQuote ||
                    loadingInsured ||
                    loadingPaymentMode ||
                    loadingComplete ||
                    loadingCatalogues ||
                    loadingStartWorkFlow ||
                    loadingPatchQuote ||
                    loadingAppointmentActionPatch, text: loadingUpdatePerson || loadingUpdateQuote || loadingPatchQuote
                    ? "Actualizando cotización..."
                    : loadingUploadDocuments
                        ? "Subiendo documento..."
                        : "Cargando...", seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast }), openPassengerModal && (_jsx(PassengerDownloadModal, { open: openPassengerModal, onClose: handlePassengerModalClose, setSeeToast: setSeeToast, quoteId: selectedQuoteId, onOpenPdf: handleOpenPdf })), showComponent ? (_jsx(Suspense, { children: _jsx(ConfirmationFormView, { onClickPassangerDownload: onClickPassangerDownload, isTravelInsurance: isTravelInsurance, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, breadcrumbs: breadCrumbs, steps: steps, 
                    /* PDF VIEWER DOCUMENT*/
                    openModal: openModalPdfViewer, setOpenModal: setopenModalPdfViewer, documentName: nameDocument, urlDocument: urlDocument, 
                    /* PDF VIEWER CLIENT*/
                    openModalClient: modalDocumentClient, setOpenModalClient: setModalDocumentClient, documentNameClient: docName, urlDocumentClient: urlDocumentClient, 
                    /* PDF VIEWER PASSENGER */
                    openModalPassenger: openModalPassenger, setOpenModalPassenger: setOpenModalPassenger, documentNamePassenger: nameDocumentPassenger, urlDocumentPassenger: urlDocumentPassenger, 
                    /* MODAL EDIT VEHICLE */
                    openModalEditVehicle: openModalEditVehicle, setOpenModalEditVehicle: setOpenModalEditVehicle, dataFormVehicle: dataFormVehicle, callQuoteOneApi: callQuoteOne, quoteId: id ? id : quoteId, planId: planId, coverTypeId: coverTypeId, campaignId: campaignId, catalogPaymentMode: catalogPaymentMode, catalogStatusQuote: catalogStatusQuote, branchId: branchId, userId: userId, idQuoteVehicle: idQuoteVehicle, productId: productId, t: t, planName: planName, productType: productType, projectTypeLocal: projectTypeLocal, salesFlow: salesFlow, 
                    /* MODAL BENEFICIARY */
                    openModalBeneficiary: openModalBeneficiary, setOpenModalBeneficiary: setOpenModalBeneficiary, isMaskedDocument: isMaskedDocument, dataFormBeneficiary: dataFormBeneficiary, titleBeneficiary: titleBeneficiary, beneficiaryType: beneficiaryType, listIdentificationType: listIdentificationType, initialPercentage: initialPercentage, handleSubmitBeneficiary: function () {
                        return handleSubmitBeneficiary(dataFormBeneficiary);
                    }, searchPerson: function (e) {
                        return searchPerson(e, setIsInsurance, setDocument, setTrigger);
                    }, 
                    /* MODAL INSURED */
                    openModalInsured: openModal, setOpenModalInsured: setOpenModal, dataFormInsurance: dataFormInsurance, titleInsured: titleInsured, insuredType: insuredType, handleSubmitInsured: function (data) { return handleSubmitInsured(data); }, searchInsurancePerson: function (e) { return searchInsurancePerson(e); }, 
                    /* MODAL CONFIRMATION */
                    openModalBackConfirm: openModalBackConfirm, handleCloseBackModal: handleCloseBackModal, handleBackFromModal: handleBackFromModal, classes: classes, 
                    /* VIEW */
                    isRequired: !isApap, tabAdditionalDocumentation: "Documentos Clientes", countBadgeContent: countBadge, customBadgeColor: "#fba730", badgeColorText: "#ffffff", additionalDocumentationColumns: AdditionalDocumentationColumns(handleClickContextMenu), additionalDocumentationRows: profileDocumentsRows, hideMarriedName: hideMarriedName, titleDrawer: "Suba el documento solicitado.", descriptionDrawer: "Arrastra el documento solicitado a la zona de color o haz clic en el área de color para seleccionarlo. Solo puedes subir un documento a la vez, y solo se permiten archivos en formato PDF.", titleUpload: "Arrastre y suelte su archivo.", heightDrawer: "100%", disableSelectCountry: true, openDrawerUpload: openDrawerUpload, onCloseDrawer: function () {
                        setOpenDrawerUpload(false);
                    }, onUpload: quoteUploadDocuments, tabAuto: "Auto Asegurado", tabAutoDescription: "", tabStatement: "Estado de cuenta", tabStatementColumns: StatementColumns(t), tabStatementRows: statementRows, TabAutoColumns: TabAutoColumns(updateVehicle, isQuote ? isQuote : ""), TabAutoRows: listVehiclesDetail, onChangeSelect: handleChangeSelect, handleChangeSelectFormInsurance: handleChangeSelectFormInsurance, 
                    // ***--- PROPS BOTONES DESCARGAR QUOTE DESDE RESUMEN
                    onClickAutoDownload: handleOnClickAutoDownload, btnLblDownload: "Descargar Cotización", btnDownloadQuoteBackground: "#ffffff", showButtonDownloadApap: !showVehicleData || !showDownloadQuote, onClickAutoDownloadVida: handleOnClickAutoDownloadVida, btnLblDownloadVida: "Descargar Solicitud", showButtonDownloadVida: !showDownloadRequest, 
                    // ***--- END PROPS BOTONES DESCARGAR QUOTE DESDE RESUMEN
                    labelNumberQuote: ((_u = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _u === void 0 ? void 0 : _u.policyId)
                        ? "No. de póliza"
                        : "No. de cotización", title: "Confirmación de datos", identificationList: listIdentificationType, GenderList: listGenders, CountryList: listCountries, ProvinceList: listRegionLevel1, TownList: listRegionLevel2, SectorList: listRegionLevel3, dataForm: dataForm, hideTabs: [
                        showInsured,
                        showBeneficiary,
                        hideTabPaymentInfo,
                        showVehicleData,
                        true,
                        hideTabDocumentClient,
                        !isTravelInsurance,
                        showTabRealEstates,
                        !showTabAppointment,
                        !showTabAppointmentManager
                    ], hideAddButton: [addInsured, addBeneficiary, true, true, !addAppointmentAction], showAdd: true, showActions: canEdit, showContactActions: canEditContact, showLocationActions: canEditLocation, showDownloads: showDownloads, onClickDownload: handleDownload, certificates: certificates, dateLabel: isQuote !== null && isQuote === "false"
                        ? "Fecha efectiva"
                        : "Fecha de cotización", downloadsTitle: "Descargas", labelAdd: "Agregar", tab1: "Personas aseguradas", tab1Description: "Asegurados", tab2: "Beneficiarios", tab2Description: "Beneficiarios", tab3: "Información de pago", tab3Description: "", Tab1Columns: columnsInsurance, Tab1Rows: rows, Tab2Columns: columnsBeneficiary, Tab2Rows: rowsBeneficiary, Tab3Columns: Tab3Columns, Tab3Rows: rows2, 
                    //Travel Insurance Tab4
                    tab4: "Pasajeros", 
                    /////
                    Tab4Columns: Tab4Columns, Tab4Rows: rowsPassengers, hide2: true, options1: paymentMode, options2: [], options3: campaignInfo, firstSubtitle: "Información de cotización", secondSubtitle: "Información general del cliente", thirdSubtitle: "Información de ubicación", fourthSubtitle: "Información de contacto", plan: plan, plans: planData.data || [], paymentMethodData: paymentMode, campaignData: campaign, showPaymentMethod: true, showCampaign: true, onClickAdd: handleAddInsured, onClickRowGrid: function () { }, onClickAddBeneficiary: handleAddBeneficiary, filters: filters, titleSelectButton: "Adquirir", previousLabel: "Anterior", nextLabel: !isVidaTermino ? "Siguiente" : "Finalizar", showPrevious: canEdit, nextDisabled: !permissions.create || !canEdit || isNextDisabled, onBack: onClickBack, onClickSave: handleUpdatePerson, onNext: handleNext, onClickPrevious: handlePrevious, onBlurInput: function () { }, onChangeInput: function () { }, onClickCancel: function () { }, disableDocumentType: true, disableDocumentNumber: true, onChangePaymentMethod: handleOnChangePaymentMethod, onChangeCampaign: handleOnChangeCampaign, onChangeCoverType: handleOnChangeCoverType, onClickAcquire: handleOnClickAcquire, disabledDownloadVida: false, isQuote: isQuote, isPlan: isPlan, openModalAddInsurance: openModalAddInsurance, setOpenModalAddInsurance: setOpenModalAddInsurance, dataFormInsuranceSp: dataFormInsuranceSp, showButtonActivatePolicy: showButtonActivatePolicy, openActivePolicy: openActivePolicy, setOpenActivePolicy: setOpenActivePolicy, policyId: policyId, callQuoteOne: callQuoteOne, onClickAddPassanger: handleAddPassanger, openModalAddPassenger: openModalAddPassenger, setOpenModalAddPassenger: setOpenModalAddPassenger, editingPassengerData: editingPassengerData, handleSavePassenger: function () { }, 
                    //home/business
                    setOpenModalAddBusiness: setOpenModalAddBusiness, openModalAddBusiness: openModalAddBusiness, isCommerce: isCommerce, tab4Description: "", TabRealEstateRows: rowsProperties, dataFormBusiness: dataFormBusiness, damageBackup: damageBackup, insuredProperty: insuredProperty, showFormBusiness: showFormBusiness, openModalAddHome: openModalAddHome, setOpenModalAddHome: setOpenModalAddHome, onSameDirection: onSameDirection, productCode: productCode, planCode: planCode, setDataFormBusiness: setDataFormBusiness, businessShift: businessShift, businessType: businessType, typeConstruction: typeConstruction, 
                    // END home/business
                    //Appoinment
                    tabAppointment: "Cita", tabAppointmentDescription: "Información de Cita", tabAppointmentColumns: columnsAppointment, tabAppointmentRows: appointmentRows, 
                    //AppointmentManager
                    tabAppointmentManager: "Gestiones", tabAppointmentManagerDescription: "Gestiones", tabAppoinmentManagerColumns: columnsAppointmentManager, tabAppointmentManagerRows: appointmentManagerRows, onClickAddAppAction: handleAddAppointmetAction, openModalAddAppointmentAction: openModalAddAppointmentAction, setOpenModalAddAppointmentAction: setOpenModalAddAppointmentAction, handleSubmitAppointmentAction: handleSubmitAppointmentAction, formAppointmentActionProps: formAppointmentActionProps }) })) : (_jsx("div", {}))] }));
};
export default ConfirmationForm;
